export default {
  language: 'Español',
  switchlangtip: 'Se ha cambiado de idioma correctamente',
  nav: {
    singeltest: 'Pruebas de llamada única',
    ai_call: 'AI Llamada',
    calling_operation: 'Operación de llamada',
    robot: 'Gestión de Chatbot',
    black_list: 'Lista negra',
    robot_list: 'Listado del robot',
    add_call: 'Agregar llamada',
    systemsettings: 'Ajustes del sistema',
    accountmanagement: 'Gestión de cuentas',
    corporateaccountinformation: 'Información de la cuenta de la empresa.',
    usermanagement: 'Gestión de usuarios',
    functionrightsrole: 'Gestión de permisos de roles',
    dashboard: 'Cuadro de mandos',
    promote: 'Promover/Promocionar',
    callcenter: 'Centro de atención telefónica',
    executecall: 'Tareas',
    detailsofcall: 'Historial de llamada',
    reportstatistics: 'Informe Estadístico',
    overallreportstatistics: 'Estadísticas globales del informe',
    speechreportstatistics: 'Estadísticas del Informe de Discursos',
    accountreportstatistics: 'Estadísticas de los informes de cuentas',
    robotreportstatistics: 'Estadísticas de los informes de robots',
    archivingcenter: 'Centro de archivo',
    historicaltaskrecord: 'Registro histórico de tareas',
    historicalcalllog: 'Historial de llamadas',
    detailsofcharges: 'Detalle de los cargos',
    testcall: 'Agregar nueva tarea',
    guide: 'Guia',
    strategy: 'Estrategia',
    plan: 'Plan',
    auditInformation: 'Tarea IC',
    PDetails: 'PDetails',
    PStrategy: 'PStrategy',
    PPlans: 'PPlans',
    ICDetail: 'Detalle IC',
    ICStrategy: 'Estrategia de llamadas de confianza',
    ICPlan: 'Mandato de la OICP',
    accessControl: 'Control de acceso'
  },
  global: {
    date: 'Seleccione la fecha',
    taskNameSelector: {
      selectLabel: 'Selección de tareas',
      selectTask: 'Seleccione el nombre de la tarea',
      selectTest: 'Por favor, seleccione el nombre de la prueba',
      allSelect: 'Todos seleccionado',
      selectWarn: 'Por favor, seleccione al menos un nombre de plan'
    },
    planNameSelector: {
      selectLabel: 'Planes',
      selectTask: 'Seleccione un nombre de plan',
      selectTest: 'Por favor, seleccione el nombre de la prueba',
      allSelect: 'Todos seleccionado',
      selectWarn: 'Por favor, seleccione al menos un nombre de plan'
    },
    distinctSelector: {
      label: 'Desmarcar',
      placeholder: 'Por favor, seleccione de-tagging'
    },
    select: 'Selecciona',
    MarketingA: 'A: Estoy interesado en',
    MarketingB: 'B: No estoy interesado en',
    query: 'Consultar',
    filter: 'Filtros',
    today: 'Hoy',
    yesterday: 'Ayer',
    nearly_three_day: 'Últimos 3 días',
    nearly_seven_day: 'Últimos 7 días',
    nearly_thirty_day: 'Últimos 30 días',
    nearly_days: 'Últimos {num} días',
    startTime: 'Fecha de inicio',
    endTime: 'Fecha final',
    batchDel: 'Eliminación por lotes',
    telNumber: 'Número de teléfono',
    triggerTime: 'Hora de activación',
    intention: 'Etiquetas',
    sort: 'Orden',
    setSort: 'Cambiar Orden',
    showName: 'Visualización de Nombre',
    totals: 'Número total',
    rounds: 'Ronda(s)',
    splitStr: ' ',
    vs: 'vs.',
    processStatus: 'Estado de procesamiento',
    pending: 'Pendiente',
    processing: 'En progreso',
    finished: 'Completado',
    toSelect: 'Seleccionar',
    editSelect: 'Cambiar selección',
    other: 'Otros'
  },
  menuNode: {
    CallTasks: 'Tareas',
    CallPlans: 'Plan',
    CallStrategy: 'Estrategia',
    CallDetails: 'Historial de llamada',
    ICDetail: 'Detalle IC',
    BlackList: 'Lista negra',
    RobotList: 'Lista de bots',
    SingleTest: 'Pruebas de llamada única',
    AddCall: 'Anadir llamada',
    Corporate: 'Información de la cuenta de la empresa.',
    UserControl: 'Gestión de usuarios',
    accountSafe: 'Gestión de Seguridad de la Cuenta',
    RolePermission: 'Gestión de permisos de roles',
    Dashboard: 'Cuadro de mandos',
    AiCalling: 'AI Llamada',
    RobotManage: 'Gestión de bots',
    CallingOperation: 'Operación de llamada',
    Inbound: 'Entrada',
    AccountManage: 'Gestión de cuentas',
    personalInfo: 'Información personal',
    systemsettings: 'Ajustes del sistema',
    collection: 'Coleccion',
    marketing: 'Mercadotecnia',
    info_check: 'Comprobación de la información',
    outbound: 'Módulo de la llamada',
    operationOutbound: 'Operaciones de salida',
    pack_up_menu: 'Menú Guardar',
    switch_old_version: 'Cambiar versión antigua',
    switch_new_version: 'Cambiar versión nueva',
    prompt_cannot_used: 'Tu cuenta se crea en la nueva versión. No se puede utilizar la versión antigua',
    personalSetting: 'Configuración personal',
    loginInfo: 'Información de acceso',
    template: 'Versión de la experiencia',
    RobotExperience: 'Experiencia con robots',
    servise_tools: 'Servicios y herramientas',
    helpCenter: 'Centro de ayuda',
    OperatingRecord: 'Registro de operaciones',
    CallAssistant: 'Asistente de llamadas',
    releaseNotes: 'Registro de versiones',
    cod: 'Comercio electrónico',
    WorkflowManger: 'Gestión de workflow',
    WorkflowTemplate: 'Modelo de workflow',
    Workflow: 'Tarea de workflow',
    SmsTemplate: 'Gestión de plantillas SMS',
    WhatsappTemplate: 'Plantilla Whatsapp',
    MultiChannelManager: 'Gestión multicanal',
    StageReport: 'Informes por etapas',
    CrossLogin: 'Suplantar',
    manual: 'Manual de instrucciones',
    document: 'Documentos API',
    add: 'Añadir',
    info: 'Ver detalles',
    copy: 'Copiar',
    edit: 'Editar',
    child: 'Ver subtareas',
    check: 'Compruebe el progreso',
    view: 'Resumen de datos',
    editRole: 'Editar función',
    addRole: 'Añadir nueva función',
    version: 'Versionado',
    batchShare: 'Compartir',
    shareLog: 'Compartir récord',
    viewData: 'Ver datos',
    Application: 'Mercado de aplicaciones',
    view_number: '明文电话号码',
    CallDetailAudioDownload: 'Descargar grabaciones en la página de detalles',
    TaskDetailAudioDownload: 'Descargar grabaciones en la página Tareas',
    PlanViewAudioDownload: 'Descargar grabaciones en la página Plan',
    ViewCallDetail: 'Ver Diálogos',
    Tools: 'Servicios y herramientas',
    WorkflowVersion: 'Gestión de versiones',
    CallLog: 'Historial de llamadas',
    chatbot: 'Chatbot',
    ChatbotOverview: 'Resumen de datos',
    ChatbotLiveMonitor: 'Monitor en vivo',
    ChatbotAnalysis: 'Análisis de los robots',
    ChatbotCR: 'grabación de la sesión',
    ChatbotSocial: 'Canal de mensajes',
    ChatbotManage: 'Gestión de Chatbot',
    ChatbotOnline: 'Robots en línea',
    ChatbotReq: 'Solicitar',
    ChatbotWBTmpl: 'Gestión de plantillas de WA',
    ChatbotWBTmplDetail: 'Detalles de la plantilla',
    ChatbotWBTmplAdd: 'Nueva plantilla',
    ChatbotWBTmplEdit: 'Editar la plantilla',
    ChatbotChat: 'Chatear',
    ChatbotTeamInbox: 'Buzón de entrada del equipo',
    ChatbotMAB: 'Difusión de marketing',
    ChatbotBroadcast: 'Lista de difusión',
    ChatbotGeneral: 'General',
    ChatbotAPI: 'Documentos API',
    ChatbotOptOut: 'Lista de Opt-out',
    InboundRobotManage: 'Gestión de Chatbot',
    InboundDashboard: 'Dashboard',
    InboundCallRecords: 'Historial de llamadas',
    timeTip: 'Sólo permite acceder en línea a los datos de los últimos 6 meses',
    timeTip2: 'Sólo admite la consulta en línea de los datos de los últimos 6 meses a partir del 1 de marzo de 2024',
    workflowTip: 'Este método sólo admite la consulta de datos generados después del 1 de febrero de 2024',
    configCenter: 'Centro de Configuración',
    accessControl: 'Control de acceso',
    holiday: 'Holiday',
    Insights: 'Perspectivas',
    ChatbotInsightsLiveMonitor: 'Monitor en directo'
  },
  account: {
    account_time_zone_new: 'Ubicación de cuentas y zonas horarias',
    cod: 'Comercio electrónico',
    template: 'Versión de la experiencia',
    administrator: 'Administrador',
    enterprise: 'Empresa',
    account_title: 'Nombre de la cuenta',
    account_country: 'Ciudad',
    account_time_zone: 'Zona horaria de la cuenta',
    account_id: 'ID de cuenta',
    corporate_contacts: 'Persona de contacto de la empresa',
    contact: 'Nombre del contacto',
    email: 'Buzón',
    phone: 'Teléfonos',
    gender: 'Genero',
    male: 'Hombre',
    female: 'Femenino',
    user_group: 'Grupos de usuarios',
    add_uer: 'Agregar al usuario',
    edit_uer: 'Usuario editorial',
    edit_group: 'Editar el grupo',
    add_group: 'Nueva agrupación',
    group_name: 'Nombre del grupo',
    user_name: 'Nombre',
    first_name: 'Nombre de pila',
    last_name: 'Apellido',
    account_number: 'Acceda a su cuenta',
    password: 'Contraseña',
    initial_password: 'Contraseña inicial',
    roleId: 'Role ID',
    lastLoginTime: 'Última hora de conexión',
    group: 'Grupo',
    role: 'carácter',
    edit: 'Editar',
    added: 'Añadir',
    enable: 'Activado',
    disable: 'Desactivar',
    save: 'Guardar ',
    reset_passwords: 'Restablecer contraseña',
    new_login_password: 'Nueva contraseña',
    set_new_login_password: 'Establecer nueva contraseña de inicio de sesión',
    error_user_tip: 'Hemos detectado que su cuenta está en riesgo. Por la seguridad de su cuenta, por favor restablezca su contraseña de inicio de sesión.',
    new_user_tip: 'Por la seguridad de su cuenta, por favor, cambie su contraseña de acceso.',
    confirm_password: 'Confirmar contraseña',
    add_role: 'Añadir nueva función',
    edit_role: 'Editar función',
    role_name: 'Nombre de la función',
    role_describe: 'Descripción de la función',
    actions: 'Operaciones',
    status: 'Estado',
    delete: 'Eliminar',
    basic_information: 'Informacion basica',
    business_type: 'Tipo de empresa',
    data_permission: 'Derechos de datos',
    fnction_permissions: 'Función Permiso',
    collection: 'Coleccion',
    marketing: 'Mercadotecnia',
    info_check: 'Comprobación de la información',
    CallingOperation: 'Operación de llamada',
    chatbot: 'Chatbot',
    select_all: 'Todos',
    clear: 'Borrar',
    all: 'Todos',
    prompt_account_name: 'Introduzca su número de cuenta y su nombre',
    prompt_password_again: 'Vuelva a introducir su contraseña',
    prompt_role_description: 'Introduzca la descripción de su personaje',
    prompt_first_name: 'Introduzca su nombre',
    prompt_last_name: 'Por favor, introduzca los apellidos',
    prompt_login: 'Introduzca la cuenta de acceso',
    prompt_password: 'Contraseña de 8-16 dígitos compuesta por números, mayúsculas y minúsculas',
    prompt_logo: 'Las imágenes pueden ser cargadas en formato jpg/jpeg/png/gif, con un tamaño inferior a 5M',
    prompt_group: 'Seleccione un grupo',
    prompt_role: 'Seleccione una función',
    prompt_role_name: 'Introduzca el nombre de la función',
    prompt_delete_role: 'Este rol está asociado a un usuario y no puede ser eliminado',
    error_logo_type: 'Sólo se admiten imágenes en formato jpg/jpeg/png/gif.',
    error_logo_size: 'El tamaño del logotipo no puede superar los 5M',
    error_cannot_exceed_200: 'No puede exceder mas de 200 caracteres',
    error_cannot_exceed_100: 'No puede exceder mas de 100 caracteres',
    error_cannot_exceed_50: 'No puede exceder mas de 50 caracteres',
    error_cannot_exceed_20: 'No puede exceder mas de 20 caracteres',
    error_group: 'No se puede eliminar porque ya hay usuarios en este grupo',
    error_group_size: 'No puede haber más de 50 grupos',
    error_login: 'La cuenta de inicio de sesión no puede estar vacía',
    error_login_exis: 'La cuenta de inicio de sesión ya existe',
    error_password: 'La contraseña debe tener entre 8 y 16 dígitos, incluyendo números y letras mayúsculas y minúsculas.',
    error_password_different: 'La contraseña no puede ser la misma 2 veces',
    error_group_name: 'El nombre del grupo no puede repetirse',
    error_enable: 'El número de usuarios habilitados no puede ser superior a {xxx}.',
    error_role_name: 'El nombre del rol no puede estar vacío',
    error_business_type: 'El tipo de empresa no puede estar vacío',
    error_first_name: 'El nombre no puede estar vacío',
    error_last_name: 'El apellido no puede estar vacío',
    error_enter_group_name: 'El nombre del grupo no puede estar vacío',
    error_new_login_password: 'La nueva contraseña de inicio de sesión no puede estar vacía',
    error_confirm_password: '2 veces la contraseña no es la misma',
    permission_list: {
      view: 'Ver',
      add: 'Añadir',
      edit: 'Editar',
      start: 'Inicio',
      delete: 'Eliminar',
      pause: 'Suspender/Reanudar',
      cancel: 'Cancelar',
      download: 'Descargar',
      copy: 'Copiar',
      enable: 'Activado',
      disable: 'Desactivar',
      ableOrNot: 'Desactivar/Activar',
      viewShield: 'Comprobar datos de bloqueo',
      allocation: 'Asignar',
      download_task: 'Descargar la tarea',
      download_roll: 'Lista de descargas',
      download_detail: 'Descargar mas detalles',
      password: 'Restablecer contraseña',
      apply: 'Aplicaciones',
      edit_remark: 'Editar Notas',
      edit_name: 'Modificar el nombre de la plantilla',
      download_subtask: 'Descargar registros de subtareas',
      view_subtask_detail: 'Ver detalles de la subtarea',
      view_subtask: 'Ver subtareas',
      add_detail: 'Añadir una lista',
      workflowProgress: 'Compruebe el progreso',
      triggerImmediately: 'Activar inmediatamente',
      categorize: 'Categorizar Event Labels',
      restore: 'Desarchivado',
      archive: 'Archivo',
      active: 'Valido',
      edit_description: 'Editar descripción',
      view_versions: 'Ver versiones',
      RobotExperience: 'Experiencia con robots',
      StageReport: 'Informes por etapas',
      CrossLogin: 'Suplantar',
      MultiChannelManager: 'Gestión multicanal',
      releaseNotes: 'Registro de versiones',
      operateWord: 'Manual de instrucciones',
      apiWord: 'Documentos API',
      OperatingRecord: 'Registro de operaciones',
      Application: 'Mercado de Aplicaciones',
      view_number: 'Número de Teléfono de Términos Claros',
      selectCountry: 'Seleccione un país',
      processProportion: 'Distribución del proceso Bot',
      labelDistribution: 'Distribución de intenciones',
      transRateTrends: 'Diferencial de llamadas y transferencias',
      transCauseDistribution: 'Distribución de motivos para el traslado de agentes',
      effectKnowledge: 'Porcentaje de conocimientos válidos',
      knowledgeHitRatio: 'Porcentaje de aciertos de conocimiento',
      hotKnowledge: 'Top10 Conocimiento popular',
      unpopularKnowledge: 'Top20 Conocimientos menos populares',
      callDimension: 'Resumen de llamadas',
      robotCalls: 'Total de llamadas',
      robotCallsProgress: 'Llamadas del robot en progreso',
      successfulTransferRate: 'Tasa de transferencias correctas',
      arCallDuration: 'Duración media de la llamada robótica',
      arInteractionRounds: 'Rondas medias de interacción con el robot',
      agentCalls: 'Llamadas de agentes',
      agentCallsProgress: 'Llamadas de agentes en progreso',
      aTransferRate: 'Tasa de transferencias intentadas',
      taCallDuration: 'Duración media total de las llamadas',
      knowledgeDimension: 'Puntos de conocimiento',
      downRecording: 'Download Recordings',
      downRecord: 'Descargar registro',
      approvalAddTask: 'Aprobación - Añadir tarea',
      approvalDownloadList: 'Aprobación - Lista de descargas',
      approvalApprove: 'Aprobación - Aprobar',
      approvalAddPlan: 'Aprobación - Añadir plan',
      approvalDownloadPlanList: 'Aprobación - Lista de descargas',
      approvalPlanApprove: 'Aprobación - Aprobar',
      ViewCallDetail: 'Ver Diálogos',
      Dashboard: 'Cuadro de mandos',
      AccountManage: 'Gestión de cuentas',
      ModifyTimeZone: 'Modificar la zona horaria',
      Corporate: 'Información de la cuenta de la empresa.',
      RolePermission: 'Gestión de las funciones',
      AiCalling: 'AI Llamada',
      CallTasks: 'Tareas',
      CallPlans: 'Plan',
      CallStrategy: 'Estrategia',
      CallDetails: 'Historial de llamada',
      transferOrNot: 'Transferir al agente o no',
      BlackList: 'Lista negra',
      CallAssistant: 'Asistente de llamadas',
      addMessage: 'Nuevo SMS colgado',
      deleteMessage: 'Borrar SMS de descolgado',
      editMessage: 'Editar SMS de conexión',
      messageStatus: 'Estado del SMS de conexión',
      viewHangUpMessage: 'Ver detalles del cuelgue',
      WorkflowDashboard: 'Actualización de contactos',
      WorkflowDashboardPage: 'Página WorkflowDashboard',
      uploadList: 'Número de contactos cargados',
      singularName: 'Desduplicación de contactos',
      numberDelisting: 'Contactos cancelados',
      numberWorkflowTasks: 'Tarea de workflow creadas',
      workflowTasksExecution: 'Tareas de flujo del trabajo en curso',
      uploadListNumberTrend: 'Tendencia de contactos subidos',
      callsInList: 'Contactos totales marcados',
      redialListNumber: 'Número de listas de desmarcación',
      numberDeconnecting: 'Número de contactos duplicados alcanzados',
      disconnectionRate: 'Tasa de conexiones únicas',
      totalNumberCalls: 'Llamadas Marcadas',
      totalNumberRounds: 'Llamadas Conectadas',
      totalConnectionRate: 'Tasa de conexión total',
      AverageConnectedCalls: 'Llamadas Marcadas Medias',
      averageNumberCalls: 'Intentos Medios de Llamada',
      onAverageNumberCalls: 'Intentos Medios por Llamada Conectada',
      averageCallDuration: 'Duración media de la llamada',
      averageInteractiveRounds: 'Número medio de rondas de interacción',
      averageRingingDuration: 'Duración media de la llamada',
      tryTurnLaborNumber: 'Intentos de transferencia a los agentes',
      attemptAgentNum: 'Intentos de transferencia a los agentes',
      attemptTransferLaborRate: 'Tasa de transferencias intentadas',
      numberSuccessfulTransfers: 'Número de transferencias realizadas con éxito',
      successRateTransfer: 'Tasa de transferencias correctas',
      robotSearch: 'Robot Búsqueda',
      platformSearch: 'Buscar según Plataforma',
      downloadData: 'Descargado',
      trendNumberCallsList: 'Tendencias del número de contactos marcados',
      labelDistributionTrend: 'Tendencia del reparto de intenciones',
      connectionRateTrend: 'Tendencia de la tasa de conexión',
      callDurationDistribution: 'Distribución de la duración de las llamadas',
      callDurationDistributionTrend: 'Tendencia de la distribución de la duración de las llamadas',
      ringClassification: 'Tipo de tono',
      hangUpSort: 'Tipo de colgado',
      trendLaborTransferRate: 'Tendencia de la tasa de transferencia',
      outboundCall: 'Outbound call',
      sms: 'sms',
      waMessage: 'WA Message',
      pds: 'PDS',
      waTemplate: 'WA Template',
      shortMessagesSent: 'Total de SMS enviados Contactos',
      smsSingularName: 'Número de listas duplicadas enviadas por SMS',
      goTo7DayHits: 'Clic en 7 días después de la deduplicación',
      goClickThroughRate: 'Índice de clics por duplicado',
      totalNumberTransmissions: 'Total Enviado',
      total7DayHits: 'Total de clics en 7 días',
      clickRate: 'Tasa de clics (CTR) ',
      averageNumberTransmissions: 'Número medio de envíos',
      trendNumberShortMessage: 'Evolución del número de listas de distribución de SMS',
      clickRateTrend: 'Evolución del porcentaje de clics',
      waSmsSingularName: 'WA Contactos Desduplicados enviados por SMS',
      waGoTo7DayHits: 'WA Clicks en 7 días tras la deduplicación',
      waGoClickThroughRate: 'WA Clicks en 7 días tras la deduplicación',
      waTotalNumberTransmissions: 'WA Total Enviados',
      waTotal7DayHits: 'WA Total 7 días Clickeado',
      waClickRate: 'Porcentaje de clics en WA',
      waAverageNumberTransmissions: 'WA Número medio de envíos',
      waTrendNumberShortMessage: 'WA Tendencia de contactos que envían SMS',
      waClickRateTrend: 'Tendencia del porcentaje de clics en WA',
      waShortMessagesSent: 'WA Total SMS Enviados Contactos',
      numberPdsList: 'Contactos PDS',
      pdsSingularName: 'Número de contactos únicos PDS',
      trendPdsListNumber: 'Tendencia de contactos PDS',
      waTemplateTotalNumber: 'Número total de contactos enviados Plantilla WA',
      waTemplateSingularName: 'Número de contactos desduplicados enviados Plantilla WA',
      wtTotalNumberTransmissions: 'WA Total SMS Enviados Contactos',
      wtAverageNumberTransmissions: 'WT Número medio de envíos',
      waTemplateIndicates: 'Evolución del número de plantillas WA enviadas Contactos',
      sendNumberTrend: 'Tendencia en el número de envíos',
      deliveryNumber: 'Número de SMS Entregados',
      successTransmissions: 'Número de SMS Enviados con Éxito',
      successResending: 'Éxito en las entregas únicas',
      waDeliveryNumber: 'Mensajes WA entregados con éxito',
      waSuccessTransmissions: 'WA Mensajes enviados correctamente',
      waSuccessResending: 'WA Éxito de las entregas únicas',
      custom_components: 'Componentes Personalizados',
      holiday: 'Holiday',
      viewDashboard: 'Resumen de datos',
      WorkflowVersion: 'WorkflowVersion',
      archive_rows: 'Ver Lista de Versión',
      WorkflowComponents: 'Componentes del flujo de trabajo',
      time: 'time',
      manual: 'manual',
      slot: 'slot',
      user_latest_intention: 'user_latest_intention',
      customized_attributes: 'customized_attributes',
      splitter: 'splitter',
      url_click: 'url_click',
      combination: 'combination',
      voicebot_call: 'voicebot_call',
      voicebot_agent_call: 'voicebot_agent_call',
      pds_call: 'pds_call',
      wa_message: 'wa_message',
      api: 'api',
      voicebot_kit: 'voicebot_kit',
      mail: 'mail',
      PDSConfig: 'Configuración PDS',
      voicemail: 'Buzón de voz',
      qa: 'QA Botón',
      contactNumberInterval: 'Intervalo del número de contacto',
      create: 'Nueva plantilla SMS',
      status: 'Estado de la plantilla',
      Tools: 'Servicios y herramientas',
      personalSetting: 'Configuración personal',
      personalInfo: 'Información personal',
      avatar: 'Modificar icono de la foto',
      email: 'Cambiar la dirección de correo electrónico',
      loginInfo: 'Información de acceso',
      '2FA': '2FA',
      viewNumber: 'Ver los Términos Claros',
      MingWenDownload: 'Descargar los Terminos Claros',
      timeZone: 'Modificar la zona horaria',
      contact: 'Visualización de Contactos de la Empresa',
      approvalBack: 'Aprobar - Retirar',
      approvalPlanBack: 'Aprobar - Retirar',
      ringSorts: 'Tipo de tono',
      updateListNumber: 'Actualización de contactos',
      accessControl: 'Control de acceso',
      BusinessInsight: 'Información empresarial',
      webhookPage: 'Configuracione de devolución de llamadas',
      callbackEvent: 'Devolución de llamada de evento ',
      encryptionPolicy: 'Devolución de llamada de evento ',
      intelligentOutbound: 'Llamada saliente inteligente',
      intelligentInbound: 'Llamada entrante inteligente',
      addCallbackEvent: 'Nueva devolución de llamada de eventos',
      simuCallback: 'Simular devolución de llamada',
      Customer: 'Gestión de clientes',
      downloadBlock: 'Descargar Datos Bloqueados',
      delBlock: 'Suprimir Datos Bloqueados',
      customSet: 'Ajustes Personalizados',
      validCallToal: 'Llamadas Conectadas Efectivas',
      validRepeatToal: 'Conexiones Efectivas Desduplicadas',
      validCallRate: 'Tasa de Conexión Efectiva',
      validRepeatRate: 'Tasa de Conexión Efectivas Desduplicadas',
      mainCallDayFB: 'Volumen diario de llamadas principales',
      pdsReasonDayFB: 'Razones de transferencia diaria',
      robotLabelDayFB: 'Distribución diaria de intenciones',
      newUserNum: 'Nuevos contactos',
      oldUserNum: 'Contactos existentes',
      orderCreateDayFB: 'Tipo de ticket diario',
      xjqsOrderDayFB: 'Recibos falsos diarios',
      validCallDes: 'Distribución válida de llamadas',
      hangTypeDes: 'Distribución de tipos de colgar',
      avgCallTimeDes: 'Distribución de la duración media de las llamadas',
      satisScoreDis: 'Calificación de Bot e índice de satisfacción',
      usersDayFB: 'Distribución diaria de contactos',
      agentAvgDuration: 'Duración media de la llamada del agente',
      falseSign: 'Falsamente firmado',
      robotPerf: 'Rendimiento de los robots',
      userStats: 'Estadísticas de contacto',
      businessView: 'Observación empresarial',
      transSuccessRate: 'Tasa de transferencias correctas',
      robotEvalRate: 'Tasa de evaluación de bots',
      robotSatisAvgScore: 'Puntuación media de satisfacción del bot',
      validCallNum: 'Volumen efectivo de llamadas',
      callerNum: 'Contactos entrantes',
      validUser: 'Contactos activos',
      repeatCallRate: 'Índice de repetición de llamadas',
      robotOneTime: 'Bot Tasa de resolución en el primer contacto',
      robotOneTimeChart: 'Bot Tasa de resolución en el primer contacto Echart',
      maxCurTrend: 'Concurrencia diaria máxima',
      dataExport: 'Exportación de datos',
      intentAccuracy: 'Precisión de la intención',
      feedback: 'Comentarios de exepción'

    },
    disabled: 'Desactivado',
    enabled: 'Activado',
    user_table: 'Lista de usuarios',
    role_table: 'Lista de roles',
    Inbound: 'Entrada',
    resMust: 'Por favor, seleccione al menos un permiso.'
  },
  dashboard: {
    noData: 'No hay datos disponibles',
    overviewDescription: 'Muestra principalmente los resultados estadísticos de las tareas de marcación.',
    totalNumOfCalls: 'Número total de personas atendidas',
    durationOfCall: 'Duración(es) total(es)',
    avDurationOfCalls: 'Duración media de las llamadas',
    reachedNum: 'Número de llamadas conectadas',
    totalCost: 'Coste total ($)',
    averageCost: 'Costo medio por llamada',
    reachedRateOfCall: 'Tasa de llamadas realizadas',
    customerIntention: 'Intenciones de los clientes',
    customerIntention_distinct: 'Intenciones de los clientes (Distintas)',
    reachedRate_distinct: 'Tasa de conexión (Distinto)',
    total_customer_distinct: 'Total de clientes',
    total_reached_distinct: 'Número total de llamadas conectadas',
    durationOfCalls: 'Duración de las llamadas',
    callLength: 'Duración de la llamada',
    number: 'Número',
    overallResult: 'Resultados de la comprobación de la información',
    comingSoon: 'Esté atento a las novedades.',
    table: {
      taskName: 'Nombre de la tarea',
      totalCost: 'Coste total ($)',
      total: 'Número total de personas atendidas',
      unreached: 'Número de llamadas perdidas',
      reached: 'Número de llamadas conectadas',
      successRate: 'Tasa de transferencias correctas',
      totalDuration: 'Duración total',
      average: 'Duración media de la llamada (s)',
      intention: 'Etiqueta de intención'
    },
    viewDataTip: 'Para más información, póngase en contacto con su gestor de clientes',
    plans: 'Previsto',
    tasks: 'Número de tareas',
    calling_tasks: 'Tareas en curso',
    pending_tasks: 'Tareas pendientes',
    total_callee: 'Número total de listas (número)',
    reached_rate: 'Tasa de conexión',
    average_call_duration: 'Duración media de las llamadas',
    average_call_waiting_duration: 'Tiempo medio de llamada',
    today: 'Hoy',
    last_three_day: 'Últimos 3 días',
    last_seven_day: 'Últimos 7 días',
    overview: 'Resumen de datos',
    call_analysis: 'Análisis de llamadas',
    vdoing: 'Dimensiones estadísticas',
    khyxzb: 'Porcentaje de intención del cliente',
    xsjgfb: 'Distribución de los resultados de la auditoría de cartas',
    callTime: 'Tiempo de llamada',
    ringType: 'Tipo de tono',
    nocallType: 'Tipo de colgado',
    callTrend: 'Tendencia de la tasa de conexión',
    byHour: 'Por horas',
    byDay: 'Por día',
    allTrend: 'Tendencia por intención',
    icResult: 'Tendencia en los resultados de las revisiones',
    duration: 'Duración media de las llamadas (segundos)',
    average_time: 'Tiempo medio de llamada',
    tasklist: 'Lista de tareas',
    total_types: 'Todas las categorías',
    all: 'Todos',
    all_task: 'Todas las tareas',
    all_robot: 'Todos los robots',
    all_results: 'Todos los resultados',
    all_trends: 'Todas las intenciones',
    shuliang: 'Cantidad/unidad',
    shichang: 'Duración/segundo',
    unduplicated: 'Despesaje',
    duplicate: 'Sin reponderación',
    totalTrend: 'Número total de resultados',
    everyCallTime: 'Duración diaria de las llamadas',
    totalNumber: 'Número total de listas',
    totalCallNumber: 'Número total de llamadas conectadas',
    totalCallRate: 'Tasa de conexión total',
    noConnectedNumber: 'Número de llamadas perdidas',
    tocallNumber: 'Número de llamadas salientes',
    max_day_data: 'Seleccione hasta 31 días de datos',
    by_task: 'Por tarea',
    by_robot: 'Por robot',
    plans_tooltip: 'Número de programaciones cuya hora de inicio se encuentra dentro del intervalo de horas de cribado',
    taks_tooltip: 'Número de tareas cuya hora de inicio se encuentra dentro del intervalo de tiempo de filtrado',
    calling_tasks_tooltip: 'Número de tareas que están siendo llamadas dentro del rango de tiempo de filtrado',
    pending_tasks_tooltip: 'Número de tareas pendientes dentro del intervalo de tiempo de filtrado',
    total_callee_tooltip: 'Número total en las condiciones de filtrado',
    reached_rate_tooltip: 'La tasa de conexión de las llamadas realizadas en condiciones de cribado',
    average_call_duration_tooltip: 'Duración media de las llamadas conectadas en condiciones de filtrado',
    average_call_waiting_duration_tooltip: 'Tiempo medio de espera de todas las llamadas realizadas en condiciones de filtrado',
    khyxzb_hover_explain: '(1) Proporción del total de las intenciones en las condiciones filtradas. \r\n(2) Diferenciado por número de teléfono',
    callTime_hover_explain: 'Distribución de la duración de las llamadas en condiciones de filtrado',
    ringType_hover_explain: 'Distribución del timbre de todas las llamadas en condiciones de filtrado',
    nocallType_hover_explain: 'Colgados de todas las llamadas en condiciones de filtrado',
    call_tip_filter_rule: '(1) Tasa diaria de llamadas alcanzadas en las condiciones filtradas.\r\n(2) Diferenciado por número de teléfono.',
    trend_tip: 'Tendencia diaria de cada etiqueta de llamada en condiciones de cribado',
    duration_tip: 'Tendencia de la duración media diaria de las llamadas en condiciones de cribado',
    average_time_tip: 'Tendencia del tiempo medio de espera de llamadas al día, en condiciones de cribado',
    tasklist_tip: 'Datos de llamadas para cada tarea en condiciones de filtrado',
    connect_number_tooltip: 'Número de todas las llamadas conectadas, por condición de filtrado',
    all_talk_time_tooltip: 'Suma de la duración de todas las llamadas conectadas en condiciones de filtrado',
    connect_number: 'Llamadas alcanzadas',
    all_talk_time: 'Duracion total de la llamada',
    dimension: 'Dimensión de-énfasis'
  },
  workbenchtable: {
    total: 'Número de llamadas',
    unreached: 'Número de llamadas perdidas',
    reached: 'Número de llamadas conectadas',
    successrate: 'Tasa de conexión',
    totalduration: 'Duración total de la llamada (s)',
    average: 'Duración media de la llamada (s)'
  },
  taskPlan: {
    tpDone: 'Aprobado',
    tpWati: 'Pendiente',
    tpReject: 'Rechazado',
    tpBack: 'Retirado',
    tpCreated: 'Creado',
    wait: 'No enviado',
    planWait: 'Se ha enviado la información del plan, espere la aprobación',
    approveTime: 'Tiempo de aprobación',
    creator: 'Creado por',
    taskStatus: 'Estado de la tarea',
    planStatus: 'Estado del plan',
    approve: 'Aprobar',
    back: 'Retirar',
    dlList: 'Lista de descargas',
    pass: 'Aprobar',
    noPass: 'No aprobado',
    confirmBack: '¿Confirmar retirada?',
    approvalOK: 'Aprobación superada, nombre de la tarea {name}',
    approvalNO: 'Aprobación fallida, nombre de tarea {name}',
    planOK: 'Aprobación superada, nombre del programa {name}',
    planNO: 'Aprobación denegada, nombre del plan {name}',
    taskBack: 'Retirar tarea: {name}',
    planBack: 'Retirar plan: {name}',
    planTime: 'Fecha prevista',
    goApprove: 'Desaprobación'
  },
  execall: {
    taskCheck: 'El tiempo de ejecución de la tarea de llamada debe ser superior al intervalo de rellamada * número de rellamadas',
    strategyCheck: 'El tiempo de estrategia debe ser superior al intervalo de rellamada * número de rellamadas',
    task: 'Tarea',
    DueDate: 'Fecha de vencimiento',
    genderselect: 'Genero',
    BorrowerName: 'Nombre del prestamista',
    BorrowedAmount: 'Importe del préstamo',
    BorrowedDate: 'Fecha del préstamo',
    TotalOwingAmount: 'Importe total adeudado',
    platName: 'Nombre de la plataforma',
    finished: 'Finalizado',
    executecall: 'Ejecutar la llamada',
    taskname: 'Nombre de la tarea',
    testname: 'Nombre de la tarea',
    voicetemplate: 'Plantillas de voz',
    calltime: 'Hora de inicio',
    endtime: 'Hora de final',
    addtasks: 'Añadir una nueva tarea',
    addstrategy: 'Añadir una estrategia',
    editstrategy: 'Editar una estrategia',
    testcall: 'Agregar nueva tarea',
    successimport: 'Importar la lista de nombres',
    updatetime: 'Hora de actualización',
    createtime: 'Tiempo de creacion',
    starttime: 'Hora de inicio',
    callstate: 'Estado de la llamada',
    operation: 'Operaciones',
    searchinfo: 'Informacion',
    Filepath: 'Ruta de archivos',
    DownLoad: 'Descargar',
    resume: 'Reanudar',
    cancel: 'Cancelar',
    source: 'Fuente',
    details: 'Detalles',
    pause: 'Pausa',
    start: 'Inicio',
    progress: 'Progreso',
    submit: 'Enviar',
    utcselect: 'Selección UTC',
    templatselect: 'Robot',
    routeselect: 'SIP',
    upload: 'Datos de carga del contacto de llamada.',
    expired: 'No es válido si ha caducado',
    recall: 'Marcar de nuevo o no',
    timeselect: 'Selección horaria',
    starttimeselect: 'Hora de inicio',
    endtimeselect: 'Hora de final',
    downtemplate: 'Muestra',
    yes: 'Si',
    no: 'No',
    interval: 'Intervalo de rellamada (minutos)',
    maxnumrecall: 'Número de rellamadas (sin la primera vez)',
    reset: 'Restablecer',
    createdtimerange: 'Seleccione una hora de creación',
    createdtimeto: 'Seleccione una hora de creación',
    tianjia_task: 'Crear tarea',
    addplan: 'Añadir un plan nuevo',
    planname: 'Nombre del plan',
    calling_strategy: 'Estrategias de llamada',
    sip: 'SIP',
    actions: 'Operaciones',
    date: 'Fecha',
    strategy: 'Estrategia',
    view: 'Ver',
    calleeNumber: 'Número de llamada',
    calltimerange: 'Hora de inicio',
    save: 'Guardar',
    addTask: 'Añadir tarea de salida',
    importNames: 'Importación de listas',
    checkNames: 'Validación de listas',
    over: 'Completado',
    input_names: 'Cargue la lista',
    download_fillin: 'Descargue la plantilla y rellene el formato',
    already_list: 'Cargue la lista completa',
    xiazai_template: 'Descargar la plantilla',
    upload_names: 'Cargar lista',
    select_drug: 'Seleccione o arrastre y suelte los archivos a esta área para cargarlos',
    error_words: '¿Confirmar para ignorar los datos erróneos y crear una tarea basada en la lista importada correctamente?',
    ten_data: 'Actualmente sólo se muestran 10 datos, para más información por favor',
    total_error_data: ' Descargar todos los datos erróneos',
    reject_number: 'Las listas importadas excluirán los números de la lista negra.',
    fail_list: 'Lista fallida',
    error_content: 'Contenido del error',
    renwu_list: 'Lista de tareas',
    line: 'Número de filas',
    all_numbers: 'Tamaño total de la lista',
    success: 'Exito',
    fail: 'Error en',
    add_plans: 'Añadir plan de llamadas',
    plan_name: 'Nombre del plan',
    check_plan: 'Ver plan',
    set_plan: 'Establecer plan de llamadas salientes',
    round: 'Ronda actual',
    reupload: 'Volver a cargar',
    import_result: 'Importar resultados',
    add_success: 'Tarea añadida correctamente',
    setDialTime: 'Por favor espere, la llamada se realizará a la hora establecida.',
    countdown: '{number} segundos después, la página se cerrará automáticamente.',
    pre_step: 'Anterior',
    next_step: 'Siguiente paso',
    create_task: 'Crear tarea',
    project_list: 'Lista de planes',
    gap_times: 'rellamada',
    gap: 'Intervalo de rellamada',
    viewRobotIntr: 'Ver Introducción al Robot',
    robotIntr: 'Introducción al robot',
    setOutboundCallPlan: 'Configuración de una tarea de salida',
    selectStartTime: 'Seleccione primero la hora de inicio',
    distance: 'Distancia a la hora de inicio',
    halfHour: '0,5 horas',
    oneHour: '1 hora',
    oneHalfHour: '1 hora y media',
    twoHours: '2 horas',
    timeHorizon: 'Seleccione una hora dentro del intervalo de 6:00-22:00',
    totalCount: 'Contactos totales marcados',
    uploadCount: 'Número de contactos cargados',
    distinctReachRate: 'Tasa de conexiones únicas',
    allstrategy: 'Todas las estrategias',
    allplan: 'Todos los planes',
    searchTip: 'Este método sólo admite la consulta de datos de llamadas generados después del 14 de abril de 2023',
    day5Error: 'Comienza y termina a más tardar el 5º día de la fecha actual.',
    fileSuccess: 'Archivo cargado correctamente'
  },
  accessControl: {
    ipBlack: 'Lista negra de IP',
    ipWhite: 'Lista blanca de IP',
    currentIP: 'La actual lista negra de IP sólo es válida para escenarios en los que el cliente accede a través de la interfaz API.',
    currentIP2: 'La lista blanca de IP actual sólo tiene efecto en escenarios en los que el cliente accede a través de la interfaz API.',
    delIP: 'Borrar dirección IP',
    addIP: 'Añadir dirección IP',
    ipAdd: 'Dirección IP',
    addBlack: 'Añadir lista negra',
    addWhite: 'Añadir lista blanca',
    editBlack: 'Editar lista negra',
    editWhite: 'Editar lista blanca',
    ipTip:
      'Admite cualquier dirección IP, como 10.0.0.10 o FF05:B5; admite direcciones en formato CIDR, como 10.0.0.0/16 o FF05:B5/60; utiliza saltos de línea para separar, y puedes añadir hasta 20 direcciones a la vez.',
    required: 'Campo obligatorio',
    noCaseIP: 'Dirección IP incorrecta',
    more20: 'Introduzca hasta 20 direcciones IP',
    confirmDeleteIP: '¿Está seguro de que desea eliminar esta IP?'
  },
  webhook: {
    callback: 'Devolución de llamada de evento ',
    encryption: 'Política de encriptación',
    itOutbound: 'Llamada saliente inteligente',
    itInbound: 'Llamada entrante inteligente',
    addCallback: 'Nueva devolución de llamada de evento',
    editCallback: 'Editar devolución de llamada de evento',
    eventType: 'Tipo de evento',
    requestURL: 'Solicitud de URL',
    requestIP: 'Solicitar IP',
    requestField: 'Parámetro de solicitud',
    muBack: 'Simular devolución de llamada',
    weSupport:
      'Para nuestro modo Webhook tradicional, necesitamos que nos proporcione una dirección de red pública para recibir mensajes de eventos. Cuando se produzca el evento correspondiente, enviaremos una solicitud HTTP POST a la dirección de red pública de su servidor, incluyendo los datos del evento en la solicitud. Si necesita una transmisión cifrada, configure la "Política de cifrado".',
    task_detail: 'Notificación de llamada finalizada en la tarea',
    task_detail_ic: 'Notificación de llamada finalizada en la tarea (Info-Checker)',
    task_end: 'Notificación de finalización de tarea',
    plan_end: 'Notificación de finalización del plan',
    wf_detail: 'Notificación de llamada finalizada en el flujo de trabajo',
    wf_detail_ic: 'Notificación de llamada finalizada en el flujo de trabajo (Info-Checker)',
    wf_apinode: 'Finalización de la llamada al flujo de trabajo y notificación de entrada en el nodo API',
    wf_detail_end: 'Notificación de finalización de la lista de flujos de trabajo',
    wf_status: 'Notificación de cambio de estado del flujo de trabajo',
    ib_transfer: 'Notificación tras la transferencia con éxito a un agente',
    ib_detail: 'Notificación al finalizar la llamada',
    verify: 'Verificación',
    verified: 'Verificado',
    verified_error: 'Verificación fallida',
    stru: 'Estructura de datos',
    show: 'Ejemplo',
    field: 'Campo',
    orMust: 'Obligatorio o no',
    tips1: `1. Las solicitudes de API admiten el esquema de autenticación de firma cifrada AES+SHA256. Los parámetros de solicitud y los datos de respuesta pueden cifrarse mediante el algoritmo AES durante la transmisión para garantizar que sólo los destinatarios autorizados puedan descifrar los datos y acceder a ellos. Al firmar los parámetros de solicitud y los datos de respuesta, se utiliza el algoritmo SHA256 para generar un compendio. El compendio se transmite junto con la solicitud o la respuesta, y el destinatario puede verificar la integridad del compendio para garantizar la integridad de los datos y evitar su manipulación. Actualmente, puede configurar su clave de cifrado (ClientEncryptionKey) para solicitarnos, así como nuestra clave de cifrado (ServerEncryptionKey) para solicitarle a usted.`,
    tips2:
      '2. Algunos datos de eventos de devolución de llamada contienen un campo de firma para verificar la integridad y seguridad de los datos de devolución de llamada. Puede configurar el CallbackSignKey para calcular la firma.',
    urlError: 'Solicitud de verificación de dirección fallida',
    requestEn: 'Clave de solicitud y clave de devolución de llamada',
    backKey: 'Clave de solicitud y clave de devolución de llamada',
    confirmSave: '¿Confirmar y guardar?',
    lii: 'Límite de la clave de cifrado del cliente: 16, 24 o 32 caracteres',
    lii2: 'Límite de la clave de cifrado del cliente: 16, 24 o 32 caracteres',
    lii32: 'Límite de la clave de devolución de llamada: 32 caracteres',
    cTooltip: 'Esta es la clave de encriptación utilizada cuando usted nos solicita, con un valor por defecto de "airudderredduria".',
    sTooltip: 'Esta es la clave de encriptación que utilizamos cuando le solicitamos eventos de devolución de llamada.',
    bTooltip: 'Este es el parámetro utilizado para calcular el campo de signo en algunos eventos de callback, con un valor por defecto de "airudder".',
    copySuccess: 'Copiado',
    viewField: 'Ver Parametros',
    urlTip:
      'Tras hacer clic en "Verificar", enviaremos una solicitud POST con formato application/json;charset=utf-8 a la dirección de solicitud para verificar la legitimidad de la dirección configurada. Esta solicitud POST contiene datos simulados para el tipo de evento correspondiente. Si se recibe un código HTTP de 200 dentro del intervalo de tiempo de reintento, la verificación se realiza correctamente; de lo contrario, la verificación falla.',
    fieldTip: 'Nota: El cambio de esta configuración también afectará a los datos de retorno de las API, incluidas las API de consulta.',
    requestUrlTip:
      'Una vez verificada la dirección de la solicitud, haga clic en el botón "Confirmar". Enviaremos una solicitud HTTP POST a la dirección de red pública del servidor, con la solicitud conteniendo datos simulados.',
    noStableIP: 'Sin IP estática',
    plwf: 'Configure la URL de devolución de llamada en la modelo de workflow.',
    pass: 'Verificado',
    noPass: 'Verificación fallida'
  },
  progress: {
    checkprogress: 'Compruebe el progreso',
    total: 'Total de envíos',
    called: 'Número de llamadas realizadas',
    unreached: 'Número de llamadas perdidas',
    reached: 'Número de llamadas conectadas',
    ok: 'OK',
    overview: 'Ver',
    title: 'Carga de',
    tip: 'Se está subiendo la lista para usted, puede tomar unos minutos, por favor espere pacientemente'
  },
  tips: {
    tips: 'llamar la atención sobre algo',
    start: '¿Está confirmado el inicio antes de tiempo?',
    cancel: '¿Estás seguro de la cancelación?',
    pause: '¿Seguro que quieres hacer una pausa?',
    resume: '¿Está seguro de reanudar?',
    close: '¿Está seguro de que desea cerrarla?',
    close_strategy: '¿Está seguro de que desea cerrar esta pantalla? Tenga en cuenta que las operaciones no se guardarán después de cerrarla.',
    loading: 'Cargando',
    plsSelect: 'Por favor, selecciona ',
    plsEnter: 'Por favor, introduzca',
    regName: 'Por favor, introduzca alfanumérico o subrayado',
    regPhone: 'Por favor, introduzca el número de teléfono correcto',
    regUrl: 'Por favor, introduzca la URL correcta',
    starttip: 'Llame ahora',
    back: 'Volver',
    confirmDel: '¿Confirmar borrado?',
    opsSuccess: 'Operación exitosa.',
    confirmCancel: '¿Estás seguro de cancelar esto?',
    repeat: 'Ya exitía este nombre'
  },
  testcall: {
    maxwarn: 'El número actual de llamadas de prueba ha superado el límite.',
    selecttimewarn: 'Seleccione el rango de tiempo creado',
    search: 'Buscar',
    type: 'Categorización',
    interval: 'Intervalo de rellamada (minutos)',
    num: 'Número de rellamadas (excluida la primera)',
    testName: 'Nombre de la prueba de llamada única',
    test: 'Pruebas de llamada única',
    inputAccount: 'Introduzca una cuenta',
    addTest: 'Especifique la política para añadir marcación',
    addTask: 'Asignación de tareas y marcación',
    addCall: 'Anadir llamada',
    account: 'Cuentas adicionales',
    taskName: 'Nombre de la tarea',
    selectTask: 'Tareas adicionales seleccionadas',
    stime: 'Hora de inicio (añadir zona horaria)',
    etime: 'Hora de finalización (añadir zona horaria)',
    sta: 'Hora de inicio (zona horaria de la cuenta)',
    eta: 'Hora de finalización (zona horaria de la cuenta)',
    subTask: 'Subtareas',
    list: 'Número de listas',
    label: 'Etiquetas',
    robotName: 'Nombre del robot',
    status: 'Estado de marcación',
    scs: 'Estrategia seleccionada',
    callTime: 'Fecha de añadir duración de marcación',
    callNum: 'Número de rondas',
    accountTime: 'Zona horaria de la cuenta',
    addType: 'Tipo de marcación',
    adds: 'Política de marcación',
    addSet: 'Configuración de marcación',
    tip: 'Nota: Todas las horas corresponden a la zona horaria de la cuenta',
    sd: 'Fecha de inicio',
    ed: 'Fecha final',
    sat: 'Seleccione la fecha en la que continuará la marcación',
    roundName: 'Nombre redondo',
    robot: 'Robot',
    st: 'Hora de inicio',
    et: 'Hora de final',
    opera: 'Operaciones',
    addc: 'Anadir llamada',
    cac: 'Anulación de la marcación adicional',
    at: 'Hora absoluta',
    rt: 'Hora de final relativa',
    atb: 'Añadir tareas por lotes',
    atbTip: 'Admite la adición por lotes, el nombre de la tarea debe tener salto de línea entre ellos.',
    adddetail: 'Añadir detalles',
    addID: 'Añadir ID',
    cat: 'Añadir tarea',
    pa: 'Por favor, seleccione primero la cuenta a añadir',
    aea: 'Añadir/Editar Añadir tarea',
    aib: 'Añadir lote',
    pst: 'Seleccione la hora de inicio.',
    pet: 'Seleccione una hora de finalización',
    reset: 'Restablecer',
    save: 'Guardar',
    ln: 'Número de listas',
    ct: 'Tiempo de creacion',
    cstatus: 'Estado de la llamada',
    remarks: 'Observaciones',
    saname: 'Nombre de la tarea para la cuenta seleccionada',
    rtst: 'Hora de inicio de la llamada saliente para la tarea asociada',
    rtet: 'Hora de finalización de la llamada saliente para la tarea asociada'
  },
  taskoverview: {
    taskoverview: 'Resumen de la tarea',
    overview: 'Resumen de datos'
  },
  formrulestips: {
    taskname: 'Por favor, ingrese el nombre de la tarea',
    strategyname: 'Introduzca un nombre de estrategia',
    planname: 'Por favor, introduzca el nombre del plan',
    strategy: 'Seleccione una estrategia de llamada',
    repeat_interval: 'Seleccione el intervalo de la rellamada',
    repeat_number: 'Por favor, seleccione las horas de rellamada',
    intention: 'Etiqueta de intención',
    base: 'Por favor, selecciona la base',
    voicetemplate: 'Por favor, seleccione una plantilla de robot',
    lineselect: 'Por favor, selecciona la linea de SIP',
    starttime: 'Por favor, ingresa la hora de comienzo ',
    date: 'Seleccione la fecha',
    endtime: 'Por favor, introduzca la hora de finalización',
    ifexpired: 'Por favor, elija si desea invalidar el que expira',
    ifrecall: 'Por favor, elige si quieres volver a marcar',
    recallinterval: 'Por favor, seleccione el intervalo de rellamada',
    maxnumrecall: 'Por favor, seleccione el número máximo de rellamadas',
    utc: 'Por favor, seleccione una zona horaria',
    yes: 'Si',
    no: 'No',
    uploadsuccess: 'Cargar correctamente',
    excelempty: 'El formulario está vacío, error de carga',
    maxlimiation: 'El número de llamadas cargadas ha alcanzado el límite',
    reset: 'Restablecer'
  },
  form: {
    upload: 'Cargar datos',
    uploadtip: 'Cargar la información de contacto',
    submit: 'Enviar',
    error: {
      uploadsize: 'Por favor, no cargue archivos de más de 1 m de tamaño.',
      uploadheader: 'Hay un error en la cabecera de Excel. Por favor, rellene los datos de acuerdo con la plantilla.',
      uploadnum: 'Sólo admite la carga de un archivo.',
      uploadformat: 'Sólo admite la carga de archivos con sufijo .xlsx, .xls, .csv'
    },
    download: 'Descargar',
    importfail: 'Error en la importación de datos',
    allfail: 'Fallo en la importación de todos los datos'
  },
  tableoperation: {
    pending: 'Llamada en espera',
    created: 'Creado',
    finished: 'Finalizado',
    canceled: 'Cancelado',
    cancel: 'Cancelar',
    paused: 'Pausado',
    reached: 'Alcanzado',
    unreached: 'No conectado',
    calling: 'Llamadas en curso',
    planned: 'Planificado'
  },
  login: {
    login: 'Iniciar sesión',
    logout: 'Salir',
    passwordLogin: 'Cuenta y Contraseña',
    ssoLogin: 'SSO',
    slogan: 'Incremente la productividad de forma excelente, impulsada con éxito por la IA',
    footer: 'Cooperación empresarial: bianca.cheng@airudder.com | Copyright 2019 airudder.com',
    business_cooperation: 'Cooperación empresarial: sales@airudder.com',
    all_right_reserved: 'Copyright {name} airudder.com',
    input_userName: 'Introduzca su número de cuenta',
    input_password: 'Introduzca su contraseña',
    login_forget: '¿Ha olvidado su contraseña?',
    concurrency_limit:
      'Su cuenta se ha iniciado sesión en otros dispositivos, para garantizar la seguridad de la cuenta, como no mi operación, por favor inmediatamente volver a iniciar sesión y cambiar la contraseña.',
    errorMessage: 'Su sesión ha expirado. Por favor, conéctese de nuevo.',
    noRegister: 'Esta cuenta no está registrada. Por favor contáctenos para registrarse y entonces reintentarlo',
    noCanSSO: 'Esta cuenta no soporta inicio de sesión de SSO. Por favor contáctenos para darle asistencia'
  },
  calldetails: {
    translationLanguage: 'Seleccione un idioma',
    prevRecord: 'Grabación anterior',
    nextRecord: 'Grabación siguiente',
    callId: 'ID de Llamada',
    dialogueRounds: 'Redondo',
    callDetails: 'Historial de llamadas',
    translation: 'Renderización',
    downloadRecord: 'Download Recordings',
    calldetails: 'Historial de llamada',
    contact: 'Nombre del contacto',
    callid: 'ID de Llamada',
    callduration: 'Duración de la llamada',
    intentionlabel: 'Etiqueta de intención',
    callresult: 'Resultado',
    download: 'Descargar',
    reached: 'Alcanzado',
    unreached: 'No conectado',
    undialed: 'Sin marcar',
    choosecreate: 'Seleccione la hora de creación',
    choosecall: 'Seleccione la hora de llamada',
    callnumber: 'Número de teléfono',
    timefrom: 'Hora de la llamada (Desde)',
    timeto: 'Hora de llamada (hasta)',
    calltimerange: 'Hora de inicio',
    inputnumber: 'Introduzca su número de teléfono',
    ringtype: 'Tipo de tono',
    hangtype: 'Tipo de colgado',
    comments: 'Observaciones',
    questions: 'Preguntas',
    icresult: 'Resultado',
    A: 'A: success',
    B: 'B: failed',
    C: 'C: unfinished',
    D: 'D: others',
    E: 'E: no-answer',
    F: 'F: not connected',
    G: 'G: voicemail',
    Yes: 'S: Sí, llamar para confirmar',
    No: 'N: No, llama para negar',
    Others: 'O: Otros, Sin respuesta o respuesta sin sentido',
    Skip: 'S: Omitir, el Robot no pidió',
    Non: '-: Esta pregunta no existe',
    resultTipTitle: 'La categoría de resultados IC está relacionada con el diseño de robots',
    questionsTipTitle: 'responder a cada unidad de preguntas',
    tableTitle: 'Lista detallada',
    prompt_robot_name: 'Seleccione un robot',
    prompt_intention: 'Seleccione una etiqueta intencionada',
    call_time: 'Hora de inicio',
    create_time: 'Tiempo de creacion',
    robot: 'Robot',
    prompt_overall_result: 'Por favor, seleccione el resultado de la revisión de la carta',
    userHangup: 'Colgado por el usuario',
    RobotHangup: 'Colgado por IA',
    agentHange: 'Colgado por el agente',
    cancelled: 'Cancelado',
    all_intention: 'Todas las intenciones',
    all_result: 'Todos los resultados',
    lettersMeaning: 'Significado de las letras de la derecha bajo cada lista de preguntas:',
    lettersMeaningLeft: 'Significado de las letras de la izquierda bajo cada lista de preguntas:',
    letterA: 'A: Respuesta del usuario llamado (denotada por «-» cuando no está disponible)',
    letterV: 'V: la información de verificación que ha cargado (indicada con «-» si no está disponible)',
    letterR: 'R: resultado de la verificación de A y V (coincidente para acuerdo, no coincidente para desacuerdo, «-» para ningún resultado de verificación)',
    mainFlow: 'Proceso principal',
    robotPhoneLabel: 'Etiquetas de llamada a robot',
    isArtificial: 'Transferir al agente o no',
    userPhone: 'Número de abonado',
    callingId: 'ID de Llamada',
    callingTime: 'Duracion total de la llamada',
    scenario: 'Escenario',
    pdfFailReason: 'Razones por las que no se transfiere a un humano',
    robotCallTime: 'Duración de la llamada del bot',
    callDuration: 'Duración de la llamada humana',
    dialogueRound: 'Rondas de conversación del bot',
    callTag: 'Etiquetas de llamadas artificiales',
    moreFilter: 'Más filtros',
    visibleFields: 'Los campos que se deben mostrar y descargar',
    hotPhone: 'Número de la línea directa',
    transfer: 'No transferido a manual',
    transferSuccess: 'Transferido con éxito ',
    transferFail: 'Transferencia fallida',
    cantConfirm: 'Lo he intentado pero no estoy seguro',
    view: 'Ver',
    hitMainProcess: 'Golpear la corriente principal del proceso',
    callTaskBeginTime: 'Hora de inicio de la tarea',
    beginCallTime: 'Hora de inicio de la llamada',
    workflowName: 'Nombre del flujo de trabajo',
    advancedSettings: 'Configuración avanzada',
    canSeeFields: 'Gestión básica de la visibilidad de los campos',
    nerSlots: 'Configuración de NER Slots',
    eventLabels: 'Configuración de etiquetas de eventos',
    listVariable: 'Configuración de Event Labels',
    showTip: 'Marque para controlar la visualización de la lista, filtrar elementos o descargas',
    call_task_name: 'Tareas',
    call_robot: 'Robot',
    wf_task: 'Tarea de workflow',
    wf_template: 'Plantilla de flujo de trabajo',
    call_plan: 'Plan',
    call_strategy: 'Estrategia',
    call_id: 'ID de Llamada',
    phone_number: 'Número de teléfono',
    call_intention: 'Etiqueta de intención',
    ringing_type: 'Tipo de tono',
    hangup_type: 'Tipo de colgado',
    transfer_status: 'Transferir al agente o no',
    platform_name: 'Platform',
    task_call_start_time: 'Hora de inicio de la tarea',
    real_call_start_time: 'Hora de inicio de la llamada',
    ner_slots: 'NER slots',
    event_labels: 'Event labels',
    talk_duration: 'Duración de la llamada',
    talk_round: 'Redondo',
    task_id: 'ID de tarea',
    contact_name: 'Nombre del contacto',
    answer_time: 'Hora de conexión',
    real_call_end_time: 'Hora de finalización de la llamada',
    call_times: 'Número de llamadas',
    call_comments: 'Comemtarios',
    asr_result: 'ASR Resultado',
    phone_call_log: 'Registros de rellamada',
    fieldShow: 'Campos y orden de visualización',
    listField: 'Campos de la lista',
    selectField: 'Habilitar filtro',
    slotsTitle: 'Descripción de las ranuras y configuración de la cabecera de la tabla de descarga',
    slotTip1: 'Descripción：La configuración de NER Slots está en el flujo del robot, todas las ranuras del robot se muestran aquí.',
    slotTip2:
      '1. Defina si desea que se muestre una ranura cuando se acierte o no según sus necesidades. Si marca «Mostrar», la ranura de aciertos y el valor de la ranura se mostrarán en los detalles de la llamada; si marca «NER slots» visibles en la lista en «Gestión de visibilidad de campos básicos», la ranura de aciertos y el valor de la ranura se mostrarán en la lista de llamadas;',
    slotTip3:
      '2. Por favor, configure si una ranura se puede ver después de que se golpea de acuerdo a sus necesidades. Si se puede ver, el texto de descripción correspondiente y el valor de la ranura se mostrará en la página después de la llamada golpea la ranura; si no hay texto de descripción está configurado, se mostrará el nombre de la ranura y el valor de la ranura;',
    slotTip4:
      '3. Por favor, configure si una ranura se puede descargar como una cabecera de tabla Excel después de que se golpea de acuerdo a sus necesidades, y otras franjas horarias y los valores de ranura se pondrán bajo el campo de cabecera de tabla de ranuras NER.',
    slotTip5: '4. Si necesita cumplir los puntos 2 y 3 anteriores, marque «NER slots» en «Gestión del campo visible».',
    slotDes: 'Descripción',
    canSee: 'Mostrar o no mostrar',
    canDl: 'Si se descarga como cabecera de tabla',
    eventTitle: 'Configuración de cabecera de tabla de descarga de Event labels',
    eventTip:
      'Descripción：Las Event labels se configuran en el flujo de robots. Las Event labels de todos los robots se muestran aquí. Por favor, configure si desea descargar una determinada Event labels como un encabezado de tabla de Excel después de que se golpea de acuerdo a sus necesidades. Otras Event labels se mostrarán bajo el mismo encabezado--Event labels, y por favor seleccione «Event labels» en la «Gestión básica de la visibilidad de los campos».',
    tableDl: 'Si se descarga como cabecera de tabla',
    listSet: 'Variables de lista Ver y descargar Ajustes de cabecera',
    variableTip:
      'Descripción: Aquí se muestran todas las variables de lista cargadas desde los últimos 6 meses hasta el día T-1. Por favor, configure si una variable de lista se puede ver en los detalles de la llamada o descargar por separado como un encabezado de Excel.',
    listTitle: 'Variables de lista Ver y descargar Ajustes de cabecera',
    listTip:
      'Nota: Aquí se muestran todas las variables de lista cargadas en los últimos 6 meses hasta el día T-1. Por favor, configure si una variable de lista puede utilizarse como elemento de filtro, mostrarse en la lista y detalles de llamadas, o utilizarse como encabezado de tabla de Excel para la lista de descarga, según sea necesario.',
    listVar: 'Lista de variables',
    callInfoTitle: 'Información sobre la asignación de llamadas',
    callInformation: 'Información de la llamada',
    listInfo: 'Información de la lista',
    listSource: 'Fuente de la lista',
    asr_ptp: 'PTP',
    detail_status: 'Estado de la lista',
    ringing_duration: 'Hora de llamada',
    openFilter: 'Habilitar filtro',
    exception_feedback: 'Comentarios de exepción',
    exCategory: 'Tipo de excepción',
    exDialogue: 'Dialogo de exepción',
    submitFeedback: 'Envíar comentarios',
    feedbackDetail: 'Detalles de los comentarios',
    bigLabelErr: 'Error de intención',
    asrErr: 'Error de ASR',
    flowErr: 'Error de flujo',
    scriptErr: 'Eror de guión',
    plsExType: 'Por favor escoja el tipo de excepción',
    plsSelectExMsg: 'Por favor consulte el dialogo de excepciones a la izquierda'
  },
  singeltest: {
    singeltest: 'Pruebas de llamada única',
    template: 'Por favor, seleccione una plantilla de robot',
    sipselect: 'Por favor, seleccione un SIP',
    calling: 'Llamar desde',
    called: 'Llamar a',
    tele: 'Por favor, introduzca el número de teléfono',
    canused: 'Importe restante',
    submit: 'Enviar',
    reset: 'Restablecer',
    numonly: 'El número de teléfono sólo puede ser numérico',
    sip: 'SIP'
  },
  cost: {
    cost: 'Precio del artículo',
    total: 'Coste total ($)',
    costtitle: 'Costo ($)'
  },
  historicaltask: {
    histaskrecord: 'Registros históricos de misiones',
    hiscallrecord: 'Historial de las llamadas'
  },
  admin: {
    admin: 'Página de administración',
    company: 'Empresa',
    companySelect: 'Por favor, seleccione el nombre de la empresa',
    type: 'Categorización',
    timeRange: 'Ámbito de la consulta',
    client: 'Nombre del cliente',
    usedate: 'Fecha de utilización',
    callnum: 'Número de llamadas efectuadas',
    reached: 'Alcanzado',
    unreached: 'No se ha alcanzado',
    cost: 'Costo ($)',
    totalcost: 'Precio total'
  },
  error: {
    404: 'Verifique si la URL que ha ingresado es correcta. Haga clic en el botón de abajo para volver a la página de inicio.',
    back: 'Pagina de inicio',
    planadd: 'El tiempo de ejecución de su plan ha excedido el tiempo original de la estrategia, por favor ajuste la estrategia e inténtelo de nuevo.'
  },
  strategy: {
    newround: 'Añadir una nueva ronda',
    list: 'Lista de políticas de llamadas',
    new: 'Añadir una nueva estrategia',
    published: 'Publicado',
    unpublished: 'Sin publicar',
    view: 'Ver',
    edit: 'Editar',
    copy: 'Copiar',
    delete: 'Eliminar',
    strategy: 'Nombre de la estrategia',
    roundname: 'Nombre redondo',
    roundnumber: 'Numero de rondas',
    strategyname: 'Nombre de la estrategia',
    entername: 'Introduzca el nombre de la estrategia',
    maxrecall: 'Tiempos máximos de rellamada',
    selecttag: 'Seleccione una etiqueta',
    selectrange: 'Seleccione la gama',
    tip: 'Consejo: ¡Las dos rondas deben estar separadas por más de 15 minutos!',
    icplandowndtip: 'Seleccione la estrategia de convocatoria de revisión de las letras',
    stratrgy_table: 'Lista de estrategias',
    prompt_strategy_name: 'Introduzca un nombre de estrategia',
    interval_time: 'El intervalo entre {round} y la ronda anterior será superior a 15 minutos.',
    view_strategy: 'Ver estrategia',
    amxTag: 'Esta ronda admite hasta 12 etiquetas, por favor, vuelva a seleccionar',
    no_robot: 'El robot no existe, inténtelo de nuevo'
  },
  robotExplain: {
    name: 'Nombre del discurso',
    language: 'Temas de debate',
    voice: 'Modo',
    range: 'Ámbito de aplicación',
    paytime: 'Pregunte por el plazo de pago',
    recorder_gender: 'Genero de la voz',
    voice_language: 'Lenguaje',
    formal: 'Formal',
    casual: 'Casual',
    polite: 'Cortés',
    natural: 'Natural',
    tough: 'Línea dura',
    tougher: 'Pulsando',
    t4: 'T-4 o superior, IVR',
    t3: 'T-3 hasta T-0',
    t0: 'T-0',
    tadd1: 'T+1 ~',
    beforedue: '~ T-1',
    today: 'Hoy'
  },
  excel: {
    appexist: 'Por favor, confirme si el nombre de la plataforma es el correcto.',
    dateformat: 'El formato de la fecha no es válido. Consulte la plantilla de muestra.',
    dateinterval: 'La «fecha_prestada» debe ser anterior a la «fecha de vencimiento».'
  },
  blacklist: {
    add: 'Añadir lista negra',
    tip1: 'Admite la carga por lotes',
    tip2: 'Se requieren saltos de línea entre los números',
    invalidTip: 'Formato inválido del número de teléfono',
    successTip: 'Anadido ccon exito',
    deleteTip: 'Confirmar para eliminar',
    deleteSuccess: 'Elimiado correctamente',
    simpleTip: 'Ejemplo',
    limit_service: 'Restricción de los servicios de marcación',
    system_names: 'Lista negra del sistema',
    manual_names: 'Lista negra manual',
    bl_type: 'Tipo de lista negra',
    bl_list: 'Lista negra'
  },
  assistant: {
    title: 'Bloqueo inteligente',
    add: 'Añadir estrategia de bloqueo inteligente',
    type: 'Categorización',
    days: 'Días de proyección',
    result: 'Resultado de la llamada',
    times: 'Total de veces',
    callTimes: 'Tiempos de marcación',
    shieldDays: 'Días de blindaje',
    shieldType: 'Modo de bloqueo',
    lastTime: 'Hora de la última actualización',
    tel: 'Número de bloqueo',
    shieldTime: 'Hora de bloqueo',
    task: 'Tarea',
    shieldData: 'Comprobar datos de bloqueo',
    pblj: 'Lógica de bloqueo: Al crear una tarea o una llamada, el sistema comprueba si las llamadas realizadas en los últimos N días cumplen las condiciones de bloqueo. \r\nEn caso afirmativo, el sistema bloqueará las llamadas con los métodos seleccionados durante M días. En caso negativo, el sistema no bloqueará las llamadas.',
    addznpbcl: 'Añadir estrategia de bloqueo inteligente',
    clsm: 'Descripción',
    leftDay: 'N días en el pasado (número de días que la política ha estado en vigor)',
    rightDay: 'M días próximos (días de bloqueo)',
    shaft: 'Línea de tiempo',
    createCalling: 'Cuándo se creó la tarea/llamada',
    timePoint: 'Momento X',
    radioOne: 'Bloqueo por número acumulado de resultados de llamadas',
    radioTwo: 'Bloqueo por número acumulado de llamadas',
    inputOne: 'Tipo de bloqueo ',
    inputTwo: 'Días de proyección',
    inputThree: 'Enmascarar condiciones de activación',
    checkboxOne: 'Enmascarar al crear la tarea',
    checkboxTwo: 'Enmascarar al llamar',
    spanOne: 'Tiempos de marcación',
    spanTwo: 'Pestaña de resultados de llamadas',
    spanThree: 'Total de veces',
    tooltip1:
      'Este tipo se bloqueará en función del número total de veces que se haya llamado al mismo teléfono con la etiqueta seleccionada dentro de los días de juicio que haya rellenado, y si la etiqueta seleccionada es más de una, el número acumulado de veces será el número acumulado de veces que se hayan sumado las múltiples etiquetas.',
    tooltip2: 'Este tipo de bloqueo se basa en el número de veces que se ha llamado al mismo teléfono dentro del número de días de juicio que haya rellenado.',
    tooltip3: 'Número de días (incluido el día) que debe controlar la política antes de bloquear el número.',
    tooltip4:
      'Es el número de días (incluido el día en que comienza el bloqueo) que la política bloqueará el número impactado; por ejemplo, si un número se bloquea durante 2 días a partir de hoy, se bloqueará hoy y mañana, y el bloqueo se cancelará después de las 23:59:59 de mañana.',
    tooltip5: 'Al crear una tarea, el número de teléfono marcado se bloqueará y no se podrá cargar.',
    tooltip6: 'Al llamar, el número de teléfono marcado se bloqueará y no se podrá marcar.',
    placeholder: 'Por favor, introduzca de 1 a 180',
    tian: 'Dias',
    ci: 'veces',
    shieldTimes: 'Número de tiempos de blindaje',
    smartNumber: 'Número de blindaje inteligente',
    rule6: 'Introduzca un número entero entre 1~180.',
    rule7: 'Introduzca un número entero positivo',
    rule1: 'Seleccione el tipo de bloqueo',
    rule2: 'Introduzca el número de días para determinar la estrategia',
    rule3: 'Introduzca las condiciones de activación del bloqueo',
    rule4: 'Introduzca el número de días de bloqueo',
    rule5: 'Seleccione el método de bloqueo',
    blockStrategy: 'Estrategia de bloqueo',
    blockTrigger: 'Estrategia de Bloqueo Activada',
    blockStartTime: 'Hora de inicio del bloque',
    blockEndTime: 'Hora del fin del bloque'
  },
  collectionTags: {},
  marketingTags: {},
  infoCheckTags: {},
  personalInfo: {
    current_password: 'Contraseña actual',
    input_current_password: 'Introduzca la contraseña actual',
    input_new_password: 'Introduzca una nueva contraseña',
    error_current_password: 'Contraseña incorrecta',
    title: 'Información personal',
    group: 'Grupo',
    role: 'Carácter',
    account: 'Número de cuenta',
    icon: 'Avatar',
    resetIcon: 'Modificar icono de la foto',
    accountInfo: 'Información sobre la cuenta',
    basicInfo: 'Informacion basica',
    new_password: 'Nueva contraseña',
    error_confirm_password: 'Confirmar contraseña no puede estar vacío'
  },
  message: {
    lessCurrentTime: 'La hora de inicio no puede ser inferior a la hora actual.',
    lessFiveMin: 'El intervalo entre la hora de finalización y la hora de inicio no puede ser inferior a 5 minutos.',
    errorStrategyTime: 'Si la hora de la política seleccionada es anterior a la hora actual, el plan no podrá crearse correctamente.',
    fail: 'Error al importar todas las listas',
    upload: 'Por favor, cargue la lista'
  },
  robot: {
    detail: 'Detalles',
    valid: 'Valido',
    invalid: 'No válido',
    state: 'Estado',
    action: 'Operaciones',
    robot_name: 'Nombre del robot',
    create_time: 'Tiempo de creacion',
    update_time: 'Hora de actualización',
    audition: 'TESTIMONIO',
    now_words: 'Tácticas actuales',
    words_list: 'Lista',
    history: 'Historia',
    create_words: 'Nuevo Mensaje',
    update_words: 'Editar guión',
    words_update: 'Editar guión',
    words_preview: 'Palabras previas',
    words: 'Temas de debate',
    apply: 'Aplicaciones',
    update: 'Editar',
    delete: 'Eliminar',
    fill_words: 'Rellene las variables de la audición',
    start_audition: 'Iniciar prueba',
    confirm_delete: '¿Estás seguro de que quieres eliminar este diálogo?',
    confirm_apply: '¿Está seguro de que desea aplicar esta técnica?',
    sensitive_word: 'Esta es una palabra sensible, por favor sustitúyala e inténtelo de nuevo.',
    suggest_cut: 'Si el diálogo dura más de 90 segundos, se recomienda reducirlo.',
    add_words: 'Añadir una nueva frase',
    apply_words: 'Aplicar',
    delete_words: 'Borrar',
    explain: 'Nota: Copie los parámetros que desee utilizar en el cuadro de texto para editar el diálogo.',
    all_params: 'Todos los parámetros',
    params_explain: 'Parámetro Descripción',
    submit: 'Enviar',
    serial_number: 'Número de serie',
    operation_type: 'Tipo de operación',
    operation_time: 'Tiempo de operación',
    operator: 'Operador',
    can_not_empty: 'Las palabras no pueden estar vacías',
    integrity: 'Rellene todas las variables de prueba',
    greetings: 'Saludo, que se generará automáticamente según el tiempo de marcación en la marcación real. ',
    borrower_name: 'Nombre de usuario, este parámetro corresponde a nombre_cliente en el modelo. ',
    gender: 'Genero',
    borrow_money: 'Importe prestado, este parámetro corresponde a borrowed_amount en el modelo. ',
    borrow_total_money: 'Importe total prestado, este parámetro corresponde a total_owing_amount en el modelo. ',
    borrow_date: 'Fecha_prestada, este parámetro corresponde a fecha_prestada en el modelo. ',
    due_date: 'Borrowed_mature_date (Fecha de vencimiento del préstamo) ',
    due_days: 'Borrowed_days_overdue, este parámetro se convierte automáticamente según due_date, no existe tal parámetro al cargar la lista. ',
    due_month: 'Meses de retraso, este parámetro se convierte automáticamente en función de la fecha de vencimiento, no existe tal parámetro al cargar la lista. ',
    platform: 'Nombre de la plataforma, este parámetro corresponde a nombre_plataforma en la plantilla.',
    borrow_month: 'Mes de préstamo, este parámetro se convierte automáticamente según borrow_date, no existe este parámetro al cargar la lista. ',
    extra_a: 'Expandir parámetro',
    extra_b: 'Expandir parámetro',
    extra_c: 'Expandir parámetro',
    extra_d: 'Expandir parámetro',
    enter: 'Por favor, introduzca',
    active: 'Valido',
    ineffective: 'Aún no en vigor',
    edit_remark: 'Editar Notas',
    remark: 'Observaciones',
    remark_max_length: 'Máximo 40 caracteres para los comentarios',
    robotId: 'ID del robot',
    idDesc: 'Este ID se utiliza principalmente para seleccionar el robot correspondiente cuando se interactúa con la API.',
    tone: 'Tono',
    robotGender: 'Genero',
    auditionRecord: 'Demostración',
    politeness: 'Cortés',
    nature: 'Natural',
    tough: 'Línea dura',
    pressure: 'Pulsando',
    cruel: 'Vicioso',
    detailTab1: 'Descripción de la etiqueta',
    detailTab2: 'Robot Variant',
    detailTable1: 'Etiquetas',
    detailTable2: 'Descripción',
    detailTable3: 'Variables  ',
    detailTable4: 'Normas',
    detailTable5: 'Ejemplos',
    labelGroup: 'Categorizar Event labels',
    groupTip:
      'Descripción：Puede establecer la agrupación de etiquetas de evento bajo el mismo robot, después del ajuste, se mostrará el nombre del nuevo grupo, si no se agrupa, sólo se mostrarán las etiquetas de evento originales.',
    groupbtn1: 'Grupo',
    groupbtn2: 'Cancelar',
    groupbtn3: 'Nombre del grupo',
    errTip: 'Seleccione multi_intention',
    groupTableTitle: 'Grupo de etiquetas de eventos',
    dashboardTip1: 'El peso de la etiqueta es {name}, se dará prioridad según este peso.',
    dashboardTip2:
      'Todos los números se refiere a todas las listas, el peso de la etiqueta es {name}, si el mismo número de teléfono en la ronda anterior en un número de etiquetas diferentes, el sistema dará prioridad a la selección de las listas de acuerdo con las etiquetas de mayor peso',
    dashboardTip3: 'Aquí se presentan las variables web y sus ejemplos; para las variables API, consulte los documentos de la API. '
  },
  safetyLogin: {
    change_email: 'Cambiar la dirección de correo electrónico',
    desc_new_email: 'Introduzca una nueva dirección de correo electrónico para la verificación',
    binding_email: 'Vincular dirección de correo electrónico',
    desc_email: 'Introduzca su dirección de correo electrónico para la verificación',
    to_bind: 'Ir a la encuadernación',
    prompt_email: 'Introduzca su dirección de correo electrónico',
    invalid_email: 'Dirección de correo electrónico no válida',
    enter_code: 'Introduzca el código de verificación',
    fetch_code: 'Obtener código de verificación',
    area_code: 'Número de teléfono Código de área',
    prompt_mobile: 'Introduzca el número de teléfono',
    bind_mobile: 'Vincular número de teléfono',
    invalid_mobile: 'Número de teléfono no válido',
    error_code: 'Código de verificación incorrecto, inténtelo de nuevo',
    prompt_area_code: 'Seleccione un prefijo telefónico internacional',
    again: 'Recuperar después de {number}s',
    safety_verification: 'Verificación de la seguridad',
    verify_desc: 'Para asegurarse de que se trata de su propia cuenta, verifíquela por correo electrónico.'
  },
  crossLogin: {
    name: 'Suplantar',
    list: 'Lista de cuentas',
    companyName: 'Nombre de la empresa',
    placeholder: 'Por favor, introduzca su nombre de usuario o empresa',
    tip: 'Actualmente atravesando el login, no soporta esta operación',
    checkout: 'Cierre de sesión'
  },
  LoginInfo: {
    login_set: 'Configuración de inicio de sesión',
    enabled: 'Activado',
    not_enabled: 'No activado',
    declare:
      'Nota: Para la seguridad de la cuenta, se recomienda activar 2FA; después de activarlo, vincule su correo electrónico para recibir un código de verificación durante la verificación de seguridad.',
    login_log: 'Registros de acceso',
    desc: 'A continuación se muestra su registro de inicio de sesión en el último mes. Si hay algún registro de inicio de sesión anómalo, cambie su contraseña lo antes posible.',
    open_FA: 'Activar 2FA',
    serial: 'Número de serie',
    equipment: 'Sistema de equipamiento',
    browser: 'Navegador',
    area: 'Area',
    login_time: 'Hora de inicio de sesión'
  },
  template: {
    callTime: 'Tiempo de llamada',
    experience_robot: 'Experimente el robot',
    select_industry: 'Elija un sector',
    desc_first: 'Elija un robot que se adapte a sus necesidades y empiece a experimentar',
    desc_second: 'El contenido que introduzcas se sincronizará automáticamente con los guiones del robot.',
    ps_industry_scenario: 'Seleccione un sector',
    ps_kansalliskieli: 'Seleccione un país-idioma',
    industry: 'Industria',
    ps_industry: 'Seleccione un sector',
    scenario: 'Escenario',
    ps_scenario: 'Seleccione un escenario',
    dial_country: 'País de marcación',
    ps_dial_country: 'Seleccione el país de marcación.',
    robot_language: 'Lenguaje robot',
    ps_robot_language: 'Seleccione un idioma para el robot',
    time_zone: 'Zona horaria',
    select_time: 'Seleccione una zona horaria',
    dial: 'Número de marcación',
    pe_dial: 'Seleccione un número de marcación',
    country_code: 'Código del país',
    pe_borrower_name: 'Introduzca el nombre del prestatario',
    pe_borrowing_balance: 'Introduzca el importe del préstamo',
    total_amount_borrowed: 'Importe total prestado',
    pe_total_amount_borrowed: 'Introduzca el importe total del préstamo',
    ps_Later_current_time: 'Introduzca una hora posterior a la actual',
    length_limit: 'La longitud debe oscilar entre 8 y 20 caracteres',
    ps_start_time: 'Seleccione la hora de inicio.',
    ps_borrowing_date: 'Introduzca una fecha de préstamo',
    ps_due_date: 'Introduzca una fecha de vencimiento',
    country: 'País',
    language: 'Lenguaje',
    recording_audition: 'Demo del audio',
    experience_immediately: 'Experimenta ahora',
    selectIndustry: 'Seleccione el sector y el escenario',
    industryList: 'Menú Industria',
    robot: 'Robot',
    timbre: 'Género de la voz',
    tone: 'Tono',
    rangeApplication: 'Ámbito de aplicación',
    allIndustry: 'Todos los sectores'
  },
  tools: {
    manual: 'Manual de instrucciones',
    document: 'Documentos API',
    product: 'Empresas',
    tip1: 'Seleccione una empresa',
    tip2: 'Seleccione un idioma',
    download_doc: 'Descargar los documentos',
    all: 'Marcar todo como leído',
    infoList: 'Lista de mensajes',
    more: 'Mas',
    viewNow: 'Ver ahora',
    newVersion: 'Ultima version',
    hisVersion: 'Versiones anteriores',
    appTip: 'Seleccione una aplicación adecuada. Una vez autorizada la aplicación, se pueden transferir datos entre AIRUDDER y la aplicación seleccionada.',
    auth: 'Solicitar autorización',
    cancelAuth: 'Cancelar autorización',
    isCancel: '¿Está seguro de que desea cancelar la autorización?'
  },
  action: {
    listTime: 'Tiempo de operación',
    list: 'Lista de Operaciones',
    listAccount: 'Cuenta de explotación',
    listModule: 'Módulo operativo',
    listContent: 'Operaciones',
    taskAdd: 'Añadir tarea {name}',
    taskOpen: 'Iniciar tarea {name}',
    taskCancel: 'Cancelar tarea{name}',
    taskStop: 'Pausar tarea{name}',
    taskRecover: 'Reanudar tarea{name}',
    taskDownloadList: 'Descargar hojas de ruta',
    taskDownloadName: 'Descargar lista de tareas{name}',
    taskDownloadDetail: 'Descargar detalles de la tarea{name}',
    planAdd: 'Añadir plan{name}',
    planCancel: 'Cancelar plan{name}',
    planDownloadList: 'Descargar listas de planes',
    planDownloadName: 'Descargar lista de planes {name}',
    strategyAdd: 'Añadir política {name}',
    strategyEdit: 'Editar política {name}',
    strategyDelete: 'Eliminar política {name}',
    callDetail: 'Descargar detalles de la convocatoria',
    blackListAdd: 'Añadir una lista negra',
    blackListDelete: 'Borrar una lista negra',
    blackListDownload: 'Descargar una lista negra',
    shieldAdd: 'Añadir política de bloqueo inteligente {name}',
    shieldEdit: 'Editar política de bloqueo inteligente {name}',
    shieldDelete: 'Eliminar política de bloqueo inteligente {name}',
    shieldStop: 'Desactivar política de enmascaramiento inteligente {name}',
    shieldOpen: 'Activar política de enmascaramiento inteligente{name}',
    robotDownload: 'Descargar un robot',
    robotEdit: 'Editar nota de {name}',
    robotAdd: 'Añadir {name}Habla',
    robotEditWord: 'Editar {name}Habla',
    robotApply: 'Aplicar {name}Habla',
    robotDelete: 'Eliminar {name}Habla',
    createTask: 'Crear tarea{name}',
    createPlan: 'Crear un plan{name}',
    callDelete: 'Cancelar llamada{name}',
    crossLogin: 'Suplantar{name}',
    tip: 'A continuación se muestra el registro de operaciones de todas las cuentas de su empresa, y admite comprobar el registro del último medio año.',
    templateSave: 'Guardar ',
    templateDel: 'Eliminar',
    workflowAdd: 'Añadir',
    workflowAddList: 'Añadir una lista',
    workflowCancel: 'Cancelar',
    versionSave: 'Guardar ',
    versionPublish: 'Publicar',
    versionActive: 'Activado',
    versionArchive: 'Archivo',
    versionSaveDes: 'Guardar la descripción'
  },
  downloadCenter: {
    downloadCenter: 'Centro de descargas',
    progress: 'Datos en preparación',
    create: 'Pendiente, procesamiento previsto en 5 minutos',
    rehandling: 'Haga clic para reprocesar',
    status5: 'Escribiendo los datos'
  },
  workFlow: {
    list: 'Lista de flujos de trabajo',
    add: 'Añadir modelo de workflow',
    workflowName: 'Nombre de la modelo de workflow',
    placeholder: 'Por favor, introduzca el Nombre del flujo de trabajo',
    name: 'Nombre',
    dec: 'Descripción',
    modifyUser: 'Operacion',
    listNum: 'Número total de listas',
    checkTask: 'Ver subtareas',
    addList: 'Añadir una lista',
    setTask: 'Configurar una tarea de flujo de trabajo',
    inputName: 'Introduzca un nombre',
    inputDes: 'Introduzca una descripción',
    timeType: 'Método de activación',
    timeType1: 'Activar a la hora especificada',
    timeType2: 'Activar después de cuánto tiempo',
    timeTip1: 'Especifique el día y la hora de activación',
    timeTip2: 'Especifique el periodo de tiempo determinado una vez finalizada la Acción asociada',
    timeTitle: 'Hora de activación',
    timeTip3: 'Seleccione la fecha',
    timeTip4: 'Seleccione el momento',
    timeV2Type: 'Método de liberación',
    timeV2Type1: 'Hora designada para la liberación',
    timeV2Type2: 'Liberación después de cierto tiempo',
    timeV2Tip1: 'La lista permanecerá en el nodo actual hasta alcanzar el tiempo establecido, entonces se liberará al nodo siguiente.',
    timeV2Tip2: 'La lista permanecerá en el nodo actual durante un tiempo determinado, después se liberará al nodo siguiente.',
    timeV2AbsoluteDateTitle: 'Fecha',
    timeV2AbsoluteDateType1: 'Cuando la lista entra en el nodo actual',
    timeV2AbsoluteDateType2: 'Al cargar la lista en Workflow',
    timeV2AbsoluteTimeTitle: 'Tiempo',
    timeV2AbsoluteTimeCurrent: 'Hora actual',
    timeV2RelativeTimeTitle: 'Hora determinada',
    timeV2RelativeTimeHour: 'horas',
    timeV2RelativeTimeMinute: 'minutos',
    dateTime: 'Hora personalizada',
    manualTitle1: 'Configuración de alertas web',
    manualTitle2: 'Hora de entrega del mensaje',
    manualTip: 'Cuánto tiempo transcurre desde que se completa la acción más reciente hasta que se recibe la alerta en el centro de mensajes de llamadas',
    uslTitle1: 'Condiciones',
    uslTitle2: 'Tipo de etiqueta',
    uslTitle3: 'Robot',
    uslTitle4: 'Etiqueta grande',
    uslTitle5: 'Etiqueta del evento',
    uslTitle6: 'Añadida una condición "o".',
    uslTitle7: 'Añadir una etiqueta de evento',
    splitterTitle1: 'Grupos',
    splitterTitle2: 'Añadir un nuevo subgrupo',
    splitterTitle3: 'La cuota de tráfico combinada del grupo experimental debe ser igual al 100%.',
    caTitle1: 'Sentencia',
    caTitle2: 'Atributo Nombre',
    caTitle3: 'Tipo de datos',
    caTitle4: 'Relación',
    caTitle5: 'Añade una sentencia "y".',
    caTitle6: 'Numérico',
    caTitle7: 'Personajes',
    caTitle8: 'Fecha',
    caTitle9: 'Hora',
    apiTip1: 'La Acción de la API devuelve los resultados de otras Acciones, por favor consulte la documentación de la API proporcionada por AIRudder para más detalles.',
    ocTitle1: 'Intervalo de rellamada',
    ocTitle2: 'Número de rellamadas',
    ocTitle3: 'Estrategia de gestión de listas',
    ocTitle4: 'Número máximo de listas por lote',
    ocTitle5: 'Tiempo de espera por lote',
    ocTip1: 'Gestione y libere las llamadas salientes por lotes.',
    ocTip2: 'Si el número de listas supera el umbral establecido, se creará un lote para llamar inmediatamente.',
    ocTip3: 'Si el tiempo supera el umbral establecido, se creará un lote para llamar inmediatamente.',
    ocTitle6: 'Cálculo automático de la duración de las tareas',
    ocTitle7: 'Duración de la tarea de salida',
    ocTip4: 'Fórmula de cálculo:',
    ocTip5: 'Duración de la tarea (min)=intervalo de rellamada*tiempos de rellamada+30min',
    ocTip6: 'Duración de la tarea (min)=número de contactos*(tiempos de rellamada+1)/concurrencia disponible+intervalo de rellamada*tiempos de rellamada+5min',
    ocEditBtn: 'Editar',
    ocLimit: 'Por favor, introduzca 10～1440.',

    smsTitle1: 'Elemento',
    smsTitle2: 'Canales',
    smsTitle3: 'Número de caracteres SMS',
    smsTitle4: 'Cambiar plantilla',
    smsTitle5: 'Seleccionar plantilla SMS',
    smsTitle6: 'Lista de plantillas SMS',
    smsTitle7: 'Seleccionar plantilla WhatsApp',
    smsTitle8: 'Lista de plantillas de WhatsApp',
    smsTitle9: 'Confirmar',
    smsTable1: 'Nombre de la plantilla',
    smsTable2: 'Contenido',
    smsTable3: 'Canales SMS',
    smsTable4: 'Número de caracteres',
    pending: 'En proceso',
    taskType: 'Tipo de tarea',
    checkLabel: 'Seleccione una etiqueta de intención o de evento',
    include: 'Contenido',
    exclude: 'No incluye',
    startswith: 'Empieza por',
    endwith: 'Termina con',
    cancelTip: 'La tarea no se puede reanudar después de la cancelación. Está seguro de que desea continuar?',
    uliTip: 'Rellene al menos una Etiqueta de Intención o una Etiqueta de Evento',
    childPending: 'Pendiente',
    searchTip: 'Todos los flujos de trabajo',
    childName: 'Nombre de la subtarea',
    callName: 'Nombre de la tarea',
    clickRateTip2: 'El denominador del porcentaje de clics calculado aquí es el número de envíos, no el número de envíos con éxito, sólo como referencia.',
    pdsTitle1: 'Grupo de agentes humanos',
    pdsTitle2: 'Intervalo de llamadas del agente',
    pdsTitle3: 'Tipo de ranura Factor de llenado',
    pdsTitle4: 'Automatico',
    pdsTitle5: 'Manual ',
    pdsTitle6: 'Tiempo máximo de llamada',
    pdsTitle7: 'Número mínimo de entradas en la lista',
    pdsTitle8: 'Tiempo de espera de la tarea',
    pdsTitle9: 'Detección de buzón de voz',
    pdsTitle10: 'Tiempo de detección de mensajes de voz',
    pdsTip1: 'Si el tiempo excede el Tiempo Máximo de Timbre antes de que sea contestada, entonces el sistema finalizará la llamada. (El tiempo máximo es de 180 segundos).',
    pdsTip2: 'Cuando el número de listas que entran en el nodo es mayor que el número mínimo de listas establecido, la tarea PDS se activa inmediatamente.',
    pdsTip3: 'Cuando el tiempo transcurrido entre la primera y la última lista introducida en el nodo supere el tiempo establecido, la tarea PDS se activará inmediatamente.',
    pdsTip4: 'Una vez finalizada la tarea, la GC se ejecutará automáticamente.',
    pdsTip5: 'Detecta si una llamada es de buzón de voz, sólo las llamadas que no son de buzón de voz se enrutan al agente.',
    pdsTip6: 'La duración máxima de una detección de buzón de voz, y después del tiempo establecido las llamadas se considerarán como llamadas sin buzón de voz.',
    pdsTip7: 'Intervalo de rellamada para llamadas desconectadas',
    pdsTip8: 'Tiempos máximos de rellamada para llamadas desconectadas',
    urlClickTitle: 'Hora de caducidad del enlace corto',
    apiTip:
      'La Acción API devolverá los resultados de ejecución de otras Acciones, el método de solicitud es POST, por favor consulte la documentación API proporcionada por AIRudder para más detalles.',
    humanAgentTitle: 'Resultados del diálogo',
    overview: 'Resumen de datos',
    dataTip1: 'Número de listas pendientes de tratamiento',
    dataTip2: 'En curso',
    dataTip3: 'Completado',
    dataTip4: 'Llamadas alcanzadas',
    dataTip5: 'Tasa de conexión',
    dataTip6: 'Mensajes enviados ',
    dataTip7: 'Clics (en 7 días)',
    dataTip8: 'Porcentaje de clics (en 7 días)',
    blocked: 'Bloqueado',
    labelTitle: 'Distribución de intenciones',
    immediately: 'Activar inmediatamente',
    obcallTitle: 'Nodo de llamada OB ascendente',
    allDataView: 'Resumen de datos',
    coTitle1: 'Seleccionar nodos',
    coTitle2: 'Nodo  ',
    coTitle3: 'Establecer la prioridad de las etiquetas de intención',
    coTitle4: 'Establecer condiciones de división',
    coTitle5: 'Condiciones de división',
    coTitle6: 'Añadir una nueva condición de división',
    coTitle7: 'Añadir un nuevo nodo',
    coTip1: 'Por favor, seleccione los nodos que necesitan fijar las Etiquetas de Intención según la prioridad. ',
    coTip2: 'Por favor, modifique la prioridad en el formato de " Etiquetas" con ">", por ejemplo "C>A>B>D>H>E>G>F".',
    coTip3: 'Las condiciones de división del flujo se mostrarán al hacer coincidir los nodos, y no deben ser las mismas.',
    chartTitle1: 'Distribución final de etiquetas',
    chartTitle2: 'Número de acciones durante la circulación de la lista',
    chartTitle3: 'Estado de la circulación de las listas',
    chartSelect2: 'Todos los canales',
    chartSelect3: 'Todas las etiquetas finales',
    checkTitle1: 'Ha estado trabajando',
    checkTitle2: 'Dias',
    checkTitle3: 'Horas',
    checkTitle4: 'Minutos',
    checkTitle5: 'Plazo de carga de la lista',
    actionViewTitle: 'Información de configuración',
    dataTip9: 'Número de listas gestionadas',
    isClick: 'Con o sin clic en 7 días',
    clickTime: 'Tiempo de clic',
    existName: 'El nombre del nodo ya existe, por favor modifíquelo e inténtelo de nuevo.',
    viewTip1: 'Número total de listas cargadas en la tarea de flujo de trabajo dentro del periodo de tiempo de selección.',
    viewTip2: 'Número medio de tiempos de marcación de salida durante la circulación dentro del periodo de tiempo de filtrado.',
    viewTip3: 'Número medio de acciones durante la circulación en un periodo de tiempo de cribado. (Excluye las acciones API).',
    viewTip4: 'Número total de tiempos de marcación de salida dentro del periodo de tiempo de filtrado. (Excluye los tiempos de rellamada en la acción).',
    viewTip5: 'Número total de llamadas conectadas durante el periodo de detección.',
    viewTip6: 'Tasa total de conexión de llamadas salientes en el periodo de detección.',
    viewTip7: 'Número total de SMS enviados durante el periodo de detección.',
    viewTip8: 'Número de clics en enlaces cortos de SMS en un plazo de 7 días desde su envío en el periodo de selección. (Sólo se contabilizarán los primeros clics).',
    viewTip9: 'Porcentaje de clics del enlace corto de SMS en los 7 días posteriores al envío durante el periodo de selección.',
    viewTip10: 'Número total de WhatsApp enviados durante el periodo de detección.',
    viewTip11: 'Número de clics en enlaces cortos de WhatsApp en un plazo de 7 días desde su envío durante el periodo de selección. (Solo se contabilizará el primer clic).',
    viewTip12: 'Porcentaje de clics del enlace corto de SMS en los 7 días posteriores al envío durante el periodo de selección.',
    viewTip13: 'Tiempos totales de marcación de PDS en el periodo de detección.',
    viewTip14: 'Número total de llamadas PDS alcanzadas dentro del periodo de tiempo de detección.',
    viewTip15: 'Tasa de conexión total de PDS en el periodo de detección.',
    viewTitle1: 'Distribución de las etiquetas finales dentro del plazo de selección.',
    viewTitle2: 'Número de acciones realizadas antes de la salida de las etiquetas finales dentro del periodo de tiempo de proyección. (Excluye las acciones API).',
    viewTitle3: 'La división de las listas entre las acciones dentro del periodo de tiempo de proyección.',
    urlClickTitle1: 'Nodos SMS/WA',
    caTitle10: 'Subcondiciones',
    slotTip: 'El tiempo de activación viene determinado por la ranura seleccionada, momento en el que la lista pasará al proceso siguiente.',
    slotTitle1: 'OB Nodo de llamada',
    slotTitle2: 'Slots',
    slotTitle3: 'Método de activación',
    slotSelect1: 'Activación puntual',
    slotSelect2: 'Activar a una hora más temprana',
    slotSelect3: 'Activar en otro momento',
    nowDay: 'El Día',
    howDay: 'Día {name}',
    delTip:
      'La eliminación de este nodo afectará a los datos de {name} y otros nodos que ya hacen referencia a este nodo, dando lugar a excepciones en el flujo de trabajo, por lo que le rogamos que modifique los datos de los nodos afectados inmediatamente después de la eliminación.',
    saveTip: 'Mensaje {name} detectado no guardado, por favor guarde y reintente',
    everyDay: 'Diario',
    ocsTitle1: 'Nombre redondo',
    ocsTitle2: 'Ronda de seguimiento y etiquetas',
    ocsTitle3: 'Intención/Event Labels',
    ocsTitle4: 'Redondo',
    ocsTitle5: 'Añadir una nueva ronda',
    ocsSort: 'Reordenar las rondas a tiempo',
    ocsError1: 'La ronda de seguimiento más temprana debe seleccionarse como "Inicial".',
    ocsError2: 'El período de tiempo de marcación de {name} debe ser mayor que el intervalo de rellamada * número de rellamadas.',
    ocsError3: 'La hora de inicio de {name} debe ser posterior a la hora de finalización de {target}.',
    ocsError4: '{name}, {target} rondas de seguimiento y etiquetas tienen duplicados',
    ocsError5: 'El nombre de una ronda tiene duplicados',
    ocsError6: 'Sólo se puede seleccionar una ronda de seguimiento como "Inicial".',
    ocsError7: 'Sólo se puede seleccionar a una persona para la ronda de seguimiento.',
    obcallTitle2: 'Nodo PDS anterior',
    close: 'Cerrar',
    errorTip1: 'No hay otros Nodos apuntando al Nodo actual.',
    errorTip2: 'La hora de activación ajustada es demasiado temprana o demasiado tardía.',
    errorTip3: 'La fecha de activación establecida es demasiado tardía.',
    errorTip4: 'No hay ninguna salida establecida en la que la condición de división sea igual a otras.',
    btn1: 'Inspeccione',
    btn2: 'Publicar',
    btn3: 'Ajustes',
    autoSave: 'Se guarda automáticamente.',
    autoSave1: 'Guardado automático',
    autoSave2: 'Intervalo de guardado automático',
    min: 'Minutos',
    on: 'Activado',
    off: 'Discapacitados',
    commonSetting: 'Configuración general',
    nodeSetting: 'Configuración del nodo de lotes',
    errTipTitle: 'Encontrado {name} error',
    errTipTip: 'Consejos: Haga clic en el nombre del nodo para localizar automáticamente el nodo problemático.',
    againCheck: 'Vuelva a inspeccionar',
    saveSuccess: 'Guardados como borradores.',
    checkSuccess: 'Inspección superada.',
    apiTitle2: 'Nodo anterior',
    apiTitle3: 'Datos personalizados',
    apiTitle4: 'Nombre del campo',
    apiTitle5: 'Valor',
    apiTitle6: 'Nuevo campo',
    apiTip3: 'Las Acciones de la API devuelven los resultados de otras Acciones, véase la sección de AIRudder ',
    apiTip4: 'la documentación de la API proporcionada por AIRudder para más detalles.',
    apiTip5: 'El nombre del campo ya existe.',
    apiVerify: 'Verificación',
    apiVerifySuccess: 'Verificado',
    apiVerifyFail: 'Verificación fallida',
    apiVerifyWarn: 'Por favor, verifíquelo primero.',
    endtimeTip: 'La tarea de flujo de trabajo sólo finalizará a la hora especificada, aunque se hayan ejecutado todos los contactos actuales.',
    autoFinishTip: 'La tarea de flujo de trabajo finalizará automáticamente cuando se ejecuten todos los contactos para el último nodo.',
    pdsReason: 'Motivo de la transferencia',
    pdsReasonTip: 'El motivo de la transferencia se muestra en la página Llamada entrante para que los agentes puedan verlo.',
    batchModify: 'Edición por lotes',
    components: 'Componente',
    addComponents: 'Nuevo componente',
    editComponents: 'Editar componente',
    saveNew: 'Guardar como nuevo componente',
    associationTemplate: 'Coherencia con la configuración de la plantilla',
    processConfig: 'Visualización de componentes',
    inputVersionDes: 'Introduzca la descripción de la versión.',
    tempDesc: 'Descripción Plantilla',
    viewComponentExecutionDetails: 'Ver detalles del componente',
    delComponent: 'Eliminar componente',
    delComponentTip: '¿Está seguro de eliminar el componente?',
    nohaveinputoroutput: 'Falta el nodo de Entrada o Salida.',
    noComponent: 'No hay ningún componente disponible, por favor cree uno nuevo primero.',
    autoFinish: 'Auto End',
    delTips: '¿Confirmar la eliminación de [{name}]?',
    tips: 'llamar la atención sobre algo',
    pdsTitle11: 'Intervalo del número de contacto',
    pdsTip9: 'Contact number interval',
    dnc: 'Estrategia DNC',
    year: 'Año',
    holidayType1: 'Liberación cuando la fecha entra en una de las siguientes categorías.',
    holidayType2: 'Liberación cuando la fecha no entra en ninguna de las siguientes categorías.',
    holidayTask1: 'Suspendido en Vacaciones',
    holidayTask2: 'En pausa en',
    holidayTip:
      '"Suspendido en Vacaciones" significa que la tarea de flujo de trabajo comienza a ejecutarse o la zona horaria de la cuenta determina a las 05:00 de cada día si el día está bajo la categoría de fecha de suspensión seleccionada, en caso afirmativo, la tarea de flujo de trabajo se suspenderá automáticamente por un día hasta las 05:00 del día siguiente para determinar de nuevo.',
    mail1: 'Destinatarios',
    mail2: 'Remitente',
    mail3: 'Lista de plantillas de correo electrónico',
    mail4: 'Seleccionar lista de plantillas de correo electrónico',
    noVariable: 'Fecha y hora predeterminadas',
    allVariable: 'Fecha y hora variables',
    fixVariable: 'Fecha fija con tiempo variable',
    fixVariable2: 'Fecha variable con hora fija',
    wabaAccount: 'WABA Cuenta',
    templateName: 'Nombre de la plantilla',
    templateContent: 'Contenido de la plantilla',
    contentView: 'Vista previa',
    selectWABATemplate: 'Seleccionar plantilla WABA',
    wabaAccountAnd: 'Lista de cuentas y plantillas WABA',
    preview: 'Vista previa',
    relateChatbot: 'Asociarse a Chatbot',
    selectChatbot: 'Seleccione Chatbot',
    robotVersion: 'Version del Bot',
    noRelateCb: 'No hay Chatbot asociado',
    preOnline: 'Pendiente de lanzamiento',
    online: 'En linea',
    noRelate: 'No asociados',
    selectRobot: 'No hay ninguna versión en línea o por lanzar del bot seleccionado.',
    selectVersion: 'El estado de la versión no es para ser lanzado o en línea.',
    wfTemplate: 'Plantillas y versiones del flujo de trabajo',
    callListTrend: 'Tendencias del número de contactos marcados',
    allLabel: 'Todas las intenciones',
    labelDistriTrend: 'Tendencia del reparto de intenciones',
    callDurationDistri: 'Distribución de la duración de las llamadas',
    callDurationTrend: 'Tendencia de la distribución de la duración de las llamadas',
    ringDistribution: 'Tipo de tono',
    uploadListTrend: 'Tendencia de contactos subidos',
    hangUpDistribution: 'Tipo de colgado',
    transferTrend: 'Tendencia de la tasa de transferencia',
    successNum: 'Número de transferencias realizadas con éxito',
    dupListNum: 'Desduplicación de contactos',
    cancelListNum: 'Contactos cancelados',
    updateListNum: 'Actualización de contactos',
    createWFTaskNum: 'Número de tarea de workflow creadas',
    runningWFTaskNum: 'Número de tarea de workflow en ejecución',
    theSameNum: 'El número de tarea de workflow en curso, con diferentes etiquetas para el mismo número de teléfono desatendidas para obtener el resultado de mayor prioridad.',
    redialListNumber: 'Número de listas de desmarcación',
    deconnecting: 'Número de contactos duplicados alcanzados',
    disconnection: 'Tasa de conexiones únicas',
    callNumbers: 'Llamadas Marcadas',
    rounds: 'Llamadas Conectadas',
    connectionRate: 'Tasa de conexión total',
    connectedCalls: 'Llamadas Marcadas Medias',
    averageNumber: 'Intentos Medios de Llamada',
    numberConnectedCalls: 'Intentos Medios por Llamada Conectada',
    averageCallDuration: 'Duración media de la llamada (s)',
    interactive: 'Número medio de rondas de interacción',
    ringingDuration: 'Tiempo medio de llamada (s)',
    turnLaborNumber: 'Intentos de transferencia a los agentes',
    transferLaborRate: 'Tasa de transferencias intentadas',
    successfulTransfers: 'Número de transferencias realizadas con éxito',
    successRate: 'Tasa de llamadas realizadas',
    shortMessage: 'Número total de listas enviadas',
    singularName: 'Número de listas enviadas por duplicado',
    waShortMessage: 'Total de contactos de WhatsApp enviados',
    waSingularName: 'Contactos únicos enviados por medio de WhatsApp',
    day7Hits: 'Clic en 7 días después de la deduplicación',
    clickThroughRate: 'Índice de clics por duplicado',
    transmissions: 'Total Enviado',
    day7HitsTotal: 'Total de clics en 7 días',
    clickRate: 'Tasa de clics (CTR) ',
    averageTransmissions: 'Número medio de envíos',
    messageSendingLists: 'Evolución del número de listas enviadas',
    clickRateTrend: 'Evolución del porcentaje de clics',
    sendNum: 'Mensajes enviados',
    click7: 'Pulsado en 7 dias',
    pdsListNum: 'Contactos PDS',
    pdsDepListNum: 'Número de contactos únicos PDS',
    pdsTitle: 'Tendencia de contactos PDS',
    waSend: 'Número total de contactos enviados Plantilla WA',
    waDupSend: 'Número de contactos desduplicados enviados Plantilla WA',
    allSend: 'Total Enviado',
    averageSend: 'Número medio de envíos',
    waSend2: 'Evolución del número de plantillas WA enviadas Contactos',
    waSendNumTrend: 'Tendencia en el número de envíos',
    includeUpload: 'Incluir todos los contactos cargados y añadidos',
    defaultCallNum: 'Por defecto, los contactos se deduplican según el número de teléfono, si hay números de teléfono duplicados en diferentes flujos de trabajo, también se deduplicarán',
    defaultCallNum2: 'Por defecto, los datos se deduplicarán por la dimensión única seleccionada. Las duplicaciones en diferentes flujos de trabajo se deduplicarán uniformemente.',
    cancelSuccess: 'Contactos cancelados exitosamente',
    updateMessage: 'Contactos actualizados correctamente',
    createSuccess: 'Tareas del flujo de trabajo creadas con exito',
    producingTasks: 'Tarea de workflow continuo',
    everyDay1: 'Cambios diarios de todos los Contactos cargados y añadidos, desduplicados por número de teléfono por defecto.',
    everyDay2: 'Cambios diarios en todas las listas que se han cargado y añadido. La regla única consiste en deduplicar según la dimensión seleccionada.',
    onlyT1: 'Sólo admite la descarga de datos sin conexión T-1',
    allList: 'Número total de listas subidas en el workflow que se han marcado al menos una vez.',
    atCallNum: 'Número total de listas marcadas tras la desduplicación por número de teléfono.',
    atCallNum2: 'Número total de listas marcadas tras la desduplicación por la dimensión de desduplicación seleccionada.',
    receivedAtLeast: 'Número total de listas conectadas subidas en workflow tras la desduplicación por número de teléfono.',
    receivedAtLeast2: 'Número total de listas conectadas subidas en workflow tras la desduplicación por la dimensión de desduplicación seleccionada.',
    dereferenceRate: 'Proporción de números de la lista conectados desduplicados con respecto a los números de la lista marcados desduplicados.',
    missedRedials: 'Número total de veces que se han marcado todas las listas, excluyendo los intentos de rellamada dentro de la misma ronda.',
    numberRounds: '电话接通的总次数',
    numberCalls: 'Proporción del total de conexiones con éxito con respecto al total de marcaciones.',
    averageRounds:
      'Número medio de veces que se han marcado llamadas conectadas, excluyendo los intentos de rellamada dentro de la misma ronda.(Este campo no se ve afectado por las selecciones de filtro de robot y plataforma.)',
    averageCallNum:
      'Número medio de veces que se ha marcado cada teléfono, incluidos los intentos dentro de la misma ronda (este campo no se ve afectado por las selecciones de filtro de robot y plataforma).',
    connectedNum: 'Número medio de veces que se han marcado llamadas conectadas, incluidos los intentos dentro de la misma ronda (este campo no se ve afectado por las selecciones de filtro de robot y plataforma). ',
    averageDuration: 'Duración media de las llamadas realizadas',
    averageActive: 'Número medio de rondas de interacción activas para las llamadas alcanzadas',
    averageRing: 'Tiempo medio de sonar las llamadas marcadas, excluyendo los intentos de rellamada dentro de la misma ronda.',
    numberAttempts: 'Número de intentos de transferir llamadas marcadas a un agente, excluyendo los intentos de rellamada dentro de la misma ronda.',
    attemptedTransfer: 'Proporción de intentos de transferencia a un agente con respecto al total de conexiones con éxito.',
    successfulCallsTransferred: 'Número de transferencias a un agente con éxito de llamadas marcadas, excluyendo los intentos de rellamada dentro de la misma ronda.',
    proportionCalls: 'Proporción de transferencias exitosas a un agente con respecto a los intentos de transferencia.',
    dialedListChanges: 'Distribución diaria de los números totales marcados de la lista y de los números marcados desduplicados de la lista.',
    theDeduplicationRule: 'Distribución de todas las etiquetas de llamada y etiquetas desduplicadas, desduplicadas por número de teléfono y prioridad de etiqueta.',
    theDeduplicationRule2: 'Distribución de todas las etiquetas de llamada y etiquetas desduplicadas, desduplicadas por la dimensión de desduplicación y la prioridad de etiqueta seleccionadas.',
    dailyCall: 'Distribución diaria de todas las etiquetas de llamadas y etiquetas desduplicadas, desduplicadas por número de teléfono y prioridad de etiqueta.',
    dailyCall2: 'Distribución diaria de todas las etiquetas de llamada y etiquetas desduplicadas, desduplicadas por la dimensión de desduplicación y la prioridad de etiqueta seleccionadas.',
    basedPhone: 'Distribución diaria de Datos duplicado y desduplicado para el número total de llamadas marcadas, llamadas conectadas y tasa de conexión.',
    allConnectedCalls: 'Distribución de la duración de todas las llamadas alcanzadas',
    durationDistribution: 'Distribución diaria de la duración de las llamadas conectadas.',
    ringTypes: 'Distribución de los tipos de timbre en todas las llamadas marcadas',
    hangUpTypes: 'Distribución de los tipos de cuelgue entre todas las llamadas marcadas',
    transferTate: 'Distribución diaria del número de transferencias, intentos de transferencia y tasas de transferencia para las llamadas conectadas.',
    sentMessages: 'Total de SMS enviados Contactos',
    messagesSent: 'Total de contactos enviados únicos por número de teléfono',
    messagesSent2: 'Número total de listas de mensajes enviados después de la deduplicación según la dimensión seleccionada',
    afterSending: 'El número de clics único según el número de teléfono, contando únicamente los enlaces cortos que se han hecho clic en un plazo de 7 días después del envío.',
    afterSending2: 'El número de clics único según la dimensión seleccionada, contando únicamente los enlaces cortos que se han hecho clic en un plazo de 7 días después del envío',
    rateSfter: 'Porcentaje de clics tras la deduplicación por número',
    shortChain: 'Sólo cuenta si se hace clic en el enlace corto en los 7 días siguientes al envío, y sólo cuenta el más antiguo si se hace clic muchas veces.',
    averageNumberMessage: 'Número medio de envíos',
    listSentmessages: 'Cambios en la lista de mensajes enviados en una base diaria, únicos según el número de teléfono',
    listSentmessages2: 'Cambios en la lista de mensajes enviados en una base diaria, únicos según la dimensión de deduplicación seleccionada',
    clickRateSent: 'Cambios en la tasa de clics diaria de los mensajes enviados, datos actualizados en el día T+1, únicos según el número de teléfono',
    clickRateSent2: 'Cambios en la tasa de clics de mensajes enviados por día, datos actualizados en el día T+1, únicos según la dimensión de deduplicación seleccionada',
    nodesToEnter: 'Número de contactos que entran en los nodos PDS (más datos disponibles en la plataforma AICC)',
    deduplicationLists: 'Número de contactos desduplicados que entran en el nodo PDS, desduplicados por número de teléfono.',
    deduplicationLists2: 'Número único de listas ingresadas en el nodo PDS, únicas según la dimensión de deduplicación seleccionada',
    listOfPDS: 'Cambios en la lista de entradas diarias al nodo PDS, únicos según el número de teléfono',
    listOfPDS2: 'Cambios en la lista de entradas diarias al nodo PDS, únicos según la dimensión de deduplicación seleccionada',
    WATemplateMessages: 'Cambios en la lista que ha recibido mensajes de plantilla de WA enviados diariamente, únicos por número de teléfono',
    WATemplateMessages2: 'Cambios en la lista que ha recibido mensajes de plantilla de WA enviados diariamente, únicos por la dimensión de deduplicación seleccionada',
    timesThatWA: 'Evolución del número de mensajes de la plantilla WA enviados al día, únicos por número de teléfono por defecto',
    timesThatWA2: 'Cambios en el número de mensajes de plantilla de WA enviados por día, únicos por la dimensión de deduplicación seleccionada',
    workflowTem: 'Modelo de workflow',
    wfDrawerTip: 'La última fecha que puede seleccionarse es dos meses a partir de la hora actual.',
    realtime: 'Tiempo real',
    offline: 'Fuera de línea',
    sendNumTip: 'El número de mensajes solicitados para ser enviados, que no representa el envío y la entrega con éxito.',
    aveTip: 'Número medio de solicitudes de envío de llamadas desatendidas',
    sendedNum: 'Entregados',
    sendedNumTip: 'Número de mensajes enviados con éxito por el operador, cuenta como 2 si el número de caracteres excede el número de caracteres para dividir 1 mensaje en 2 para su envío.',
    sendSuc: 'Número de entregas con éxito',
    sendedNumTip2: 'Número de veces que el operador realiza con éxito una entrega tras recibir una solicitud.',
    uniqSendSuc: 'Número de envíos realizados con éxito',
    uniqSendedNumTip: 'Número de veces que una solicitud fue enviada con éxito a un operador después de la eliminación del énfasis por número de teléfono.',
    uniqSendedNumTip2: 'Número de veces que se ha enviado correctamente una solicitud a un operador tras la eliminación del énfasis por la dimensión de eliminación del énfasis seleccionada.',
    clickRateTip: 'Porcentaje de clics en el enlace corto en los 7 días siguientes al envío como porcentaje del número de envíos con éxito (los clics múltiples se cuentan como 1 solo)',
    uniqClickRateTip: 'Número de clics en los enlaces cortos en los 7 días siguientes al envío como porcentaje del número de envíos realizados con éxito (los clics múltiples sólo se cuentan como 1)',
    confirmTime: 'Por favor, confirme que esta modelo de workflow requiere una duración mínima de tiempo de ejecución de',
    noMore62: 'La duración máxima de tiempo de ejecución no debe superar los 62 días.',
    minTime: 'Duración mínima de ejecución',
    delSelect: 'Borrar elementos seleccionados',
    batchAddHoliday: 'Añadir días festivos personalizados por lotes',
    uploadCustom: 'Importar vacaciones personalizadas',
    check: 'Calibración',
    title2: 'Cargue el archivo completo',
    fileTypeError: 'El formato del archivo no es correcto, inténtelo de nuevo.',
    max2M: 'Cargue un archivo de menos de 2 MB.',
    pleaseUpload: 'Por favor, cargue primero un archivo.',
    dlError: 'Descargar y ver los motivos de los fallos',
    allData: 'Datos totales',
    calendarUpload: 'Se han cargado las vacaciones.',
    calendar5s: 'La página se cerrará automáticamente en 5 segundos.',
    delTip2: 'Las vacaciones personalizadas pueden estar referenciadas en la modelo de workflow. Tenga cuidado al eliminarlos.',

    labelLevel: 'Prioridad de Etiqueta',
    labelCombination: 'Combinación de Etiqueta',
    effectCallDefinition: 'Definición de Llamada Efectiva',
    effectCallDefinition2: 'Dimensión de la Definición de Llamada Efectiva',
    effectCallDefinition3: 'Duración Mínima de Llamada Efectiva',
    labelLevelTip: 'Nota: Puedes cambiar la prioridad de las etiquetas arrastrándolas; cuanto antes las ordenes, mayor será la prioridad. Los cambios realizados aquí afectarán a todos los datos históricos de etiquetas desduplicadas.',
    dimensionTip: 'Nota: Después de seleccionar diferente dimensiones desduplicadas, puedes ver diferentes datos desduplicados en el dashboard de datos. ',
    labelCombinationTip: 'Nota: Después de combinar diferentes etiquetas, puedes ver la proporción de etiquetas de forma combinada en el dashboard.',
    effectCallDefinitionTip: 'Nota: Póngase en contacto con nosotros para configurar la duración efectiva de la llamada y el periodo efectivo. Aquí solo se muestra el resultado de la configuración.',
    validCallToalTip: 'Número total de todas las llamadas efectivas conectadas. La definición de llamadas efectivas se encuentra en "Ajustes Personalizados".',
    validRepeatToalTip: 'Número total de conexiones efectivas tras la deduplicación por número de teléfono.',
    validRepeatToalTip2: 'Número total de conexiones efectivas tras la desduplicación por el número total de las dimensiones desduplicadas seleccionadas.',
    validCallRateTip: 'Proporción del total de conexiones efectivas con respecto al total de marcaciones.',
    validRepeatRateTip: 'Proporción de conexiones efectivas desduplicadas con respecto a números de lista marcados desduplicados.'
  },
  ca: {
    action: 'Parámetro de acción',
    list: 'Parámetros de la lista',
    system: 'Parámetros del sistema',
    diy: 'Parámetros personalizados',
    common: 'Parámetros generales',
    fun: 'Parámetros operativos',
    funTip: 'Descripción de funciones',
    bj1: 'Desde... hasta...',
    bj2: 'Está vacío',
    bj3: 'No está vacío',
    bj4: 'Vacaciones o no',
    max: 'Valor máximo',
    min: 'Valor mínimo'
  },
  desc: {
    date_sub_desc: 'El número de días puede obtenerse restando los parámetros de los datos.'
  },
  channel: {
    tableTitle: 'Lista de plantillas',
    name: 'Nombre de la plantilla',
    content: 'Información',
    str: 'Número de caracteres',
    num: 'Información',
    channel: 'Canales',
    conventional: 'Robots normales',
    diy: 'Robots IVR personalizados',
    change: 'Cambiar el género de la voz',
    record: 'Género de la voz',
    speed: 'Velocidad de emisión',
    contentTip:
      '①Si hay un enlace en el SMS, se convertirá en un enlace corto dedicado al enviarlo. Entonces se podrán contar los clics de los usuarios; ②Si hay un {xxx} en el SMS, es una variable de la plantilla, que diferirá según las variables que hayas cargado.',
    strTip: 'Se trata del número de caracteres previsto, que varía en función del contenido real del enlace o de la variable del mensaje.',
    sendTime: 'Tiempo de envio',
    templateName: 'Plantilla SMS'
  },
  eventLabel: {
    label: 'Etiqueta del evento',
    attr: 'Atributos de las etiquetas',
    drawerTitle: 'Evento Etiqueta Descripción',
    all: 'Todos los mensajes',
    more: 'Mas'
  },
  checkDetail: {
    ringTime: 'Hora de llamada',
    totalNumberCalls: 'Total de llamadas',
    callHistory: 'Registros de llamadas',
    questionNumber: 'Número de serie de la pregunta',
    problemDesc: 'Descripción del problema',
    topic: 'Tipo de pregunta',
    whetherAnswer: 'Contestado o No',
    answer: 'Respuesta',
    variable: 'Variables  ',
    checkResults: 'Resultados de la verificación',
    checkDialogue: 'Ver Diálogos',
    previousDetail: 'Detalles anteriores',
    nextDetail: 'Detalles siguientes',
    history: 'Historia',
    know: 'Entendido',
    clickDesc: 'Haga clic para ver los detalles y obtener más información sobre la convocatoria.',
    whether: 'Sí / No Preguntas',
    multiple: 'Elección múltiple',
    open: 'Preguntas abiertas'
  },
  report: {
    titleTip: '(sólo admite la visualización de datos generados después de {name})',
    time: 'Periodo de tiempo',
    compared: 'Compara con',
    deduplication: 'Único o no',
    listNum: 'Número total de listas',
    connectNum: 'Llamadas alcanzadas',
    connectRate: 'Tasa de conexión',
    duration: 'Duración media de las llamadas (segundos)',
    business: 'Datos comerciales',
    robot: 'Rendimiento de los robots',
    turn: 'Conectado o no',
    beforeOverdue: '~ T-1',
    todayOverdue: 'T-0',
    overdue: 'T+1 ~',
    labelRate: 'Etiqueta Tasa de activación',
    month: 'Por mes',
    week: 'Por semana',
    onWeek: 'Week {name}',
    unduplicated: 'Despesaje',
    duplicate: 'Sin reponderación',
    labelTip1: 'Número total de listas cargadas dentro del tiempo de cribado.',
    labelTip2: 'Número total de listas a las que se ha llamado dentro del tiempo de cribado.',
    labelTip3: 'Tasa de conexión de las listas a las que se llama dentro del tiempo de cribado.',
    labelTip4: 'Duración media de las listas a las que se ha llamado durante el tiempo de filtrado.',
    type: 'Categorización'
  },
  version: {
    viewarchive: 'Ver archivo',
    archive: 'Archivo',
    id: 'Versión',
    description: 'Descripción de la versión',
    templateId: 'ID de plantilla',
    save1: 'Iterar y publicar',
    save2: 'Publicar como nueva versión',
    save3: 'Activar esta versión',
    save4: 'No activar esta versión',
    saveTip: 'Cuando esté activada, esta versión sustituirá a la que esté activada en ese momento.',
    draft: 'Borradores',
    time: 'Tiempo de archivo',
    re: 'Desarchivado',
    user: 'Archivado por',
    pdsQA: 'Auto QA',
    success: 'Activado con éxito',
    resuccess: 'Desarchivado con éxito.',
    delsuccess: 'Archivado con éxito.',
    savesuccess: 'Guardado con éxito.',
    pop: 'Esta versión ya está disponible. Se creará una versión preliminar basada en esta versión.',
    version: 'Version',
    listTime: 'Tiempo de carga de la lista'
  },
  experience: {
    robotNameTip: 'Por favor ingrese el nombre del Bot',
    shareLog: 'Compartir récord',
    shareBatch: 'Compartir   ',
    playAudio: 'Reproducir una grabación',
    experience: 'Intentar ahora',
    share: 'Compartir ahora',
    step1: 'Rellene los datos básicos.',
    step2: 'Establecer el Senario y el Bot',
    step3: 'Establecer variable',
    step4: 'Completado',
    shareNmae: 'Compartir nombre',
    language: 'Lenguaje',
    validity: 'Periodo de validez',
    callCountry: 'País de marcación',
    shareTime: 'Fecha de caducidad',
    zh: 'Chinese',
    en: 'English',
    ba: 'Bahasa',
    copyLink: 'Copiar el link',
    qrcode: 'Ver el codigo QR',
    view: 'Ver datos',
    disable: 'Desactivar',
    linkLog: 'Historial de navegación de enlaces',
    customerLog: 'Registros de la experiencia del cliente',
    check: 'Ver detalles',
    logTime: 'Tiempo de navegación',
    browser: 'Navegador',
    device: 'Dispositivo',
    city: 'Ciudad',
    isExperience: 'Intentar o no',
    shareTitle: 'Compartir',
    dec: 'Descripcion del bot',
    enterShare: 'Confirmar para compartir',
    noVar: 'No es necesario configurar ninguna variable para este bot.',
    callNumber: 'Numero de telefono',
    waitCall: 'Por favor, espere un momento, la llamada se marcará en breve.',
    reCall: 'Volver a marcar el número',
    activeSuccess: 'Establecido con éxito como inválido.',
    ruleName: 'Introduzca el nombre de la acción.',
    ruleLanguage: 'Seleccione el idioma.',
    ruleTime: 'Seleccione el periodo de validez.',
    ruleCounty: 'Seleccione el país de marcación.',
    ruleDesc: 'Por favor, introduzca la Descripción del Bot.',
    fail: 'El enlace actual no funciona, póngase en contacto con la persona que lo comparte',
    sceneName: 'Nombre del escenario',
    sceneDesc: 'Descripción del escenario ',
    canModify: 'Modificable por el cliente',
    calltitle: 'Rellenar información',
    successTitle: 'Enviado con éxito.',
    wait: 'No enviado',
    waitNext: 'La llamada se realizará en breve.',
    cut: 'Dividir los robots del escenario',
    cutTip: 'Si necesitas combinar varios bots en un escenario para compartirlos, arrastra y suelta los bots en el mismo escenario.',
    codeTip1: 'Escanee para probar el robot de voz inteligente',
    codeTip2: 'Este código QR caducará el {time}.',
    downCode: 'Descargar Código QR',
    tips: '¿Está seguro de que desea desactivarla?',
    tempDesc: 'Descripción Plantilla',
    sceneRepeat: 'El nombre del escenario ya existe.',
    callTime: 'Tiempo de llamada',
    otherRob: 'Otros robots',
    failTime: 'Tiempo de lapso',
    gender: 'Género de la voz'
  },
  v_privatization: {
    templateContent: 'Contenido de la plantilla',
    insertUrl: 'Insertar URL de destino',
    templatePlaceholder: 'Introduzca el nombre de la plantilla.',
    templateContentPlaceholder: 'Introduzca el contenido de la plantilla.',
    channelPlaceholder: 'Seleccione el canal de envío.',
    SMSTemplate: 'Plantilla SMS',
    WhatsAppTemplate: 'Plantillas de WhatsApp',
    createSMSTemplate: 'Nueva plantilla SMS',
    editSMSTemplate: 'Editar plantilla SMS',
    createWhatsAppTemplate: 'Añadir plantilla de WhatsApp',
    editWhatsAppTemplate: 'Editar plantilla de WhatsApp',
    SMSTip:
      'Descripción: Después de introducir la URL original, haga clic en "Insertar URL de destino" para insertar el enlace en el SMS al enviarlo. La URL de destino es el enlace corto que se envía al contacto, a través del cual se contabilizan los clics del enlace. El recuento de palabras y el número de SMS son resultados estimados. Para obtener resultados exactos, pruébalo tú mismo.',
    WhatsAPPTip:
      'Nota: Después de introducir la URL original, haga clic en "Insertar URL de destino" para insertar el enlace en el mensaje al enviarlo. La URL de destino es el enlace corto enviado al contacto, a través del cual se contabilizan los clics del enlace. El recuento de palabras y el número de mensajes SMS son resultados estimados. Para obtener resultados exactos, pruébalo tú mismo.',
    hangUpMessage: 'Mensaje de colgado',
    hangUpMessageAdd: 'Nuevo mensaje de colgado',
    hangUpMessageEdit: 'Editar mensaje de colgado',
    hangUpMessageTip: 'Si la estrategia de envío de mensajes en varias rondas está activada, en esta ronda no se enviarán mensajes a los contactos que serán llamados en la siguiente ronda.',
    callResult: 'Resultado de la llamada',
    messageType: 'Tipo de mensaje',
    messageTemplate: 'Plantilla de mensajes',
    messageChannel: 'Canal de mensajes',
    messageNumber: 'Número de mensajes',
    messageTip:
      '① Se contabilizarán los clics de los usuarios en el enlace corto del SMS; ② El {xxx} es una variable en la plantilla del SMS, por lo que, se enviarán varios textos a diferentes contactos en función de los contenidos cargados.',
    channel: 'Canales',
    platformPlaceholder: 'Seleccione una plataforma',
    addMessage: 'Añadir plantilla de mensaje',
    activeStatusTip: '¿Está seguro de que desea activar la plantilla?',
    inactiveStatusTip: '¿Estás seguro de que quieres desactivar la plantilla?',
    activeHangUpStatusTip: '¿Estás seguro de que quieres activar este SMS de colgado?',
    inactiveHangUpStatusTip: '¿Estás seguro de que quieres desactivar este mensaje de colgado?',
    operateSuccess: 'Operación exitosa.',
    licenseValidityPeriod: 'Periodo de validez de la licencia',
    maxCallConcurrency: 'Concurrencia máxima de llamadas',
    LicenseTip: 'Recordatorio de expiración de licencia',
    licenseWillExpired: 'Recordatorio: Su Licencia expirará en {day} día(s), después de lo cual ya no podrá acceder. Por favor contacte a AIRUDDER para renovar la licencia a tiempo.',
    licenseExpired: 'Recordatorio: Su Licencia ha expirado para {expired} día(s). No podrá utilizarla a menos que la renueve en {last} días. Por favor contacte a AIRUDDER para renovar la licencia. ',
    licenseInvalid: 'La licencia ha caducado y ya no puede utilizarse.'
  },
  calendar: {
    title: 'Gestión del calendario',
    lab1: 'Lista de vacaciones',
    lab2: 'Distribución del calendario',
    type: 'Categorización',
    dayName: 'Vacaciones',
    addDay: 'Añadir vacaciones personalizadas',
    day1: 'Día laborables',
    day2: 'Día no laborable',
    day3: 'Vacaciones legales',
    day4: 'Vacaciones a medida',
    tip: 'Lógica de juicio: La lista se evaluará cuando entre en este nodo, o a las 05:00 horas del día según la zona horaria de la cuenta. Si no cumple los requisitos para ser liberada, se volverá a evaluar a las 05:00 horas del día siguiente. \r\nEste proceso continuará hasta que la lista cumpla las condiciones de liberación para el día en curso, lo que le permitirá pasar a los pasos siguientes.',
    r1: 'Utilizar el Bot original',
    r2: 'Seleccione un bot'
  },
  inbound: {
    screeningConditions: 'Filtros',
    talkedByRobots: 'Total de llamadas',
    talkingByRobots: 'Llamadas del robot en progreso',
    stRate: 'Tasa de recepción de agentes',
    stTip: 'Llamadas transferidas con éxito a manual/total de llamadas',
    raTalkTime: 'Duración media de la llamada robótica',
    raTalkRounds: 'Rondas medias de interacción con el robot',
    tbAgents: 'Llamadas de agentes',
    tbTip: 'Número de llamadas transferidas con éxito a manual',
    tbAgents2: 'Llamadas de agentes en progreso',
    tttRate: 'Tasa de transferencias intentadas',
    tttTip: 'Llamadas intentadas a manual/total de llamadas',
    tatTime: 'Duración media total de las llamadas',
    tatTip: 'Duración media de las llamadas entre bot y usuario + humano y usuario',
    tickets: 'Tickets creados',
    graphics: 'Gráfico',
    prceProcess: 'Porcentaje de llamadas de bots por procesos',
    calls: 'Llamadas realizadas',
    rate: 'Porcentaje   ',
    allProcess: 'Todos los procesos',
    rlDistribution: 'Distribución de intenciones',
    dtReason: 'Distribución de motivos para el traslado de agentes',
    dtNodes: 'Distribución de nodos de transferencia',
    kwnlPoint: 'Porcentaje de aciertos de conocimiento',
    hitValid: 'Conocimientos válidos',
    useRate: 'Índice de utilización de los conocimientos',
    knRoundNum: 'Las rondas de diálogo llegan al conocimiento',
    allRoundNum: 'Total de rondas de conversación',
    validPer: 'Porcentaje de conocimientos válidos',
    top10: 'Top10 Conocimiento popular',
    top20: 'Top20 Conocimientos menos populares',
    knName: 'Conocimientos',
    mainProcess: 'Proceso principal',
    hotline: 'Línea directa',
    inbound: 'Entrada',
    inAndOut: 'Entrada+Salida',
    userSatis: 'CSAT',
    star1: '1 punto',
    star2: '2 puntos',
    star3: '3 puntos',
    star4: '4 puntos',
    star5: '5 puntos',
    satisRate: 'Puntuación CSAT',
    userNum: 'Contactos',
    rotTip2:
      'Porcentaje de llamadas válidas sin segundas llamadas de abonados, la estadística aquí es la tasa de resolución única para cada día natural, si el periodo de cribado es de más de 1 día, el numerador es la suma del número de llamadas válidas sin segundas llamadas para cada día en el periodo de tiempo seleccionado',
    rotTip: 'Llamadas efectivas sin segundas llamadas/llamadas válidas del día',
    ctuTip: 'Número de llamadas entrantes desatendidas por número entrante',
    etuTip: 'Número de usuarios que tuvieron al menos una ronda de llamadas interactivas válidas con el bot desactivado por número de entrada',
    totalEffectCallNum: 'Total de llamadas activas',
    noSecondCallNum: 'Llamada efectiva de contactos sin segundas llamadas entrantes',
    oneTimeRate: 'Tasa de resolución en el primer contacto',
    taiTip: 'Número de llamadas transferidas con éxito a manual/llamadas intentadas transferir a manual',
    rjTip: 'Porcentaje de llamadas calificadas que han dado lugar a una calificación de satisfacción',
    raTip: 'Grado de satisfacción medio de todas las llamadas',
    reCallNum: 'Llamadas repetidas',
    reCNTip: 'Número de llamadas por día que no son la primera llamada, como total de llamadas - número de usuarios entrantes',
    rcrTip: 'Llamadas repetidas/llamadas totales',
    rcrTip2: 'Porcentaje de llamadas entrantes repetidas como proporción del total de llamadas por día natural. Si el periodo de tiempo filtrado es superior a 1 día, el porcentaje representa un valor medio diario.',
    taTip: 'Porcentaje de llamadas transferidas con éxito a un agente de las llamadas que intentan transferirse a un agente',
    ctTip: 'El número de llamadas entrantes deduplicadas por número entrante.',
    euTip: 'El número de llamadas efectivas desduplicadas por números entrantes.',
    rcTip:
      'La proporción de llamadas entrantes repetidas respecto al número total de llamadas, aquí es la estadística de llamadas entrantes repetidas por día natural, si el tiempo de cribado es superior a 1 día, es el valor medio de cada día',
    orTip:
      'Porcentaje de llamadas válidas sin segundas llamadas entrantes de abonados (aquí está la tasa de resolución única por día natural, o el valor medio de cada día si el periodo de filtrado es superior a 1 día)',
    orTip2:
      'Porcentaje de llamadas válidas en las que el usuario no realizó una segunda llamada (aquí están los datos del día T-1, y las estadísticas son la tasa de resolución única para cada día natural)',
    oneRateTip: 'Aquí están los datos del día T-1',
    realtimeData: 'Datos en tiempo real',
    offlineData: 'Datos sin conexión',
    robotSatis: 'Tasa de satisfacción de los robots',
    rsTip: 'Porcentaje de todas las convocatorias evaluadas calificadas de "satisfactorias".',
    robotSatisTip: 'Porcentaje de llamadas con una puntuación de 3 o superior en todas las llamadas calificadas.',
    robotJudgeNum: 'Número de evaluaciones de bots',
    robotSatisNum: 'Número de Bot Satisfechos',
    thisDayNoBack: 'Llamadas válidas sin un segundo intento de llamada en el mismo día',
    thisDayMax: 'La máxima concurrencia del día',
    showAndDlField: 'Los campos para visualizar y descargar',
    allCountry: 'Todos los países',
    untriggered: 'Sin desencadenar',
    unrated: 'Sin clasificar',
    robotSatisRate: 'Puntuación de satisfacción del bot',
    indicators: 'Norma',
    labelPriority: 'Prioridad de intención',
    dlData: 'Descargado',
    offlineTip: 'Los datos de este módulo se generan para T+1 días, si se selecciona la hora para el día, no hay visualización de datos.',
    slotTip1: 'Descripción：La configuración de NER Slots está en el flujo del robot, todas las ranuras del robot se muestran aquí.',
    slotTip2:
      '1. Defina si desea que se muestre una ranura cuando se acierte o no según sus necesidades. Si marca «Mostrar», la ranura de aciertos y el valor de la ranura se mostrarán en los detalles de la llamada;',
    slotTip3:
      '2. Por favor, configure si una ranura se puede descargar como una cabecera de tabla Excel después de que se golpea de acuerdo a sus necesidades, y otras franjas horarias y los valores de ranura se pondrán bajo el campo de cabecera de tabla de ranuras NER.',
    slotTip4: '3. Si necesita cumplir los puntos 2 y 3 anteriores, marque «NER slots» en «Gestión del campo visible».',
    diffTime: 'Tiempo de comparación',
    minValidInteractives: ' Rondas Humano-Bot',
    minValidInteractives2: 'Min. Rondas Humano-Bot',
    robotTimeLeast: 'Mínimo. Bot Válido Duración de la llamada',
    effectCallSetTip: 'Nota: Cambie la definición de llamadas efectivas y visualícela en el panel de datos.',
    orders: 'Total Tickets',
    xjqsOrders1: 'Recibos falsos totales',
    xjqsOrders2: 'Entradas falsas únicas diarias',
    xjqsOrders3: 'Total de entradas falsas únicas',
    hangAINum: 'Llamadas colgadas AI',
    hangUserNum: 'Llamadas colgadas de usuario',
    hangeAgentNum: 'Llamadas colgadas de agentes',
    tbAgentsTip1: 'Número de llamadas en curso con Bot',
    tbAgentsTip2: 'Número de llamadas en curso con el agente',
    callTimeTip: 'El periodo actual y el periodo anterior para calcular los datos de periodo sobre periodo vienen determinados por el intervalo de tiempo seleccionado, ya sea un solo día o un intervalo de varios días. Por ejemplo, si se selecciona "Hoy", el periodo actual es hoy y el periodo anterior es ayer. Si se selecciona "Últimos 3 días", el periodo actual son los últimos 3 días y el periodo anterior son los 3 días anteriores.',
    tbAgentsTip: 'Llamadas transferidas con éxito a los agentes',
    stRateTip: 'Llamadas transferidas con éxito a agentes/ Llamadas totales',
    tttRateTip: 'Llamadas transferidas intentadas/ Llamadas totales',
    toArtiRateTip: 'Llamadas transferidas con éxito a agentes/Llamadas transferidas intentadas ',
    attAgentNumTip: 'Número de llamadas intentadas transferidas sobre el total de llamadas',
    validCallNumTip: 'Consulte "Ajustes personalizados" para conocer la definición de Llamadas efectivas.',
    tatTimeTip: 'Duración media de toda la llamada, incluidas las partes de bot y agente.',
    raTalkTimeTip: 'Duración media de la llamada para la parte bot',
    agentAvgDurationTip: 'Duración media de la llamada para la parte del agente',
    validCallDesTip: 'Distribución diaria de llamadas totales y llamadas efectivas (se puede ver la definición de llamada efectiva en "Ajustes personalizados")',
    everydayMaxTip: 'La punta de Concurrencia diaria a nivel de minutos (datos T-1, no disponibles para el día mismo)',
    raTalkRoundsTip: 'Número medio de rondas de interacción entre bot y usuario',
    robotJudgeRateTip: 'Porcentaje de llamadas calificadas sobre el total de llamadas con evaluaciones de satisfacción activadas.',
    robotSatisAvgScoreTip: 'La puntuación media de satisfacción de todas las llamadas (calculada a partir de las llamadas con puntuaciones reales).',
    robotOneTimeRateTip: 'La puntuación media de satisfacción de todas las llamadas (calculada a partir de las llamadas con puntuaciones reales).',
    robotOneTimeRateTip2: 'Porcentaje diario de llamadas efectivas sin llamadas posteriores del usuario, tal como se define en"Ajustes personalizados" (datos T-1, no disponibles para el día mismo).',
    prceProcessTip: 'Proporción del volumen de llamadas de cada proceso principal dentro del volumen total de llamadas.',
    noCurDaySeeTip: 'Datos T-1, no disponibles para el día mismo.',
    intentAccuracyTip: 'Precisión de reconocimiento de la intención de los robots (datos T-1, no disponibles para el día mismo).',
    newUserNumTip: 'Número de personas que llaman por primera vez',
    oldUserNumTip: 'Número de llamadas repetidas',
    validPerTip: 'Número y porcentaje de puntos de conocimiento efectivos alcanzados de entre todos los puntos de conocimiento, lo que indica la eficacia del diseño de la base de conocimientos para responder a las consultas reales de los usuarios.',
    kwnlPointTip: 'Distribución diaria de rondas de aciertos de conocimiento, rondas totales y su ratio, indicando la cobertura de la base de conocimiento de las consultas de los usuarios.',
    top10_tip: 'Los 10 puntos de conocimiento más consultados aparecen en orden descendente de frecuencia de aciertos (turnos de diálogo).',
    top20_tip: 'Lista de puntos de conocimiento nunca alcanzados',
    minValidRoundTip: 'Durante la conversación entre humano y robot, el usuario habla al menos una vez, incluso utilizando el teclado del teléfono.',
    isFalseSign: 'Firmado falsamente o no',
    falseSignOD: 'Recibos falsos',
    realCall: 'Llamadas en tiempo real',
    vaildUser: 'Usuario válido',
    ticketType: 'Tipo de billete'
  },
  chatbot: {
    reason: 'Motivo',
    indicator: 'Cuadro de mandos',
    graphics: 'Visualización de datos',
    social: 'Redes sociales',
    allSocial: 'Todas las redes sociales',
    allCountry: 'Todos los países',
    sessionData: 'Datos de la sesión',
    resTime: 'Tiempo de respuesta',
    today: 'Hoy',
    yesterday: 'Ayer',
    robotSessionNum: 'Sesiones Bot',
    satisRate: 'Puntuación CSAT',
    likeFWRate: 'Puntuación de satisfacción del agente',
    robotEnd: 'Finalizado por Bot',
    botQueueTimeout: 'Tiempo de espera de la cola de robots',
    userEnd: 'Finalizado por usuario',
    agentEnd: 'Finalizado por agentes',
    robotChatCondition: 'Sesiones Bot',
    sessionEndReason: 'Motivos del final',
    intentionDistribution: 'Distribución de servicios activada',
    identifyDistribution: 'Distribución de reconocimientos',
    knowledgeBase: 'Base de conocimientos',
    intention: 'Etiqueta de intención',
    chat: 'Chit chatear',
    unrecognized: 'No reconocido',
    robotCondition: 'Distribución del reconocimiento de robots',
    top10: 'Top10 Conocimiento popular',
    words: 'Temas de debate',
    knowledgePoints: 'Conocimientos',
    triggerRate: 'Tiempos de activación/Relación',
    star1: '1 Estrella',
    starVal: '{num} estrella',
    userNum: 'Contactos',
    sessionNum: 'Número de sesiones iniciadas por los usuarios',
    repeatRate: 'Número de sesiones iniciadas por un usuario que inició varias durante el día/ Número total de todas las sesiones',
    repeatRate2: 'Tarifa multisesión de hoy',
    userNews: 'Número de mensajes enviados por los usuarios',
    robotTimes: 'Sesiones atendidas por el bot, tiempo medio de ejecución de una sola respuesta',
    robotBFNum: 'Número de clientes actualmente en sesión con el bot',
    artificialNum: 'Número de sesiones transferidas de bot a humano',
    robotWaitNum: 'Número de sesiones en espera de bot',
    artificialWaitNum: 'Número de sesiones en espera de agente',
    artificialCalls: 'Tiempo medio de ejecución de una sola respuesta para las sesiones atendidas por el agente',
    callsAvg: 'Tiempo medio de respuesta única',
    sessionAvg: 'Número medio de minutos para todas las sesiones',
    robotSessionAvg: 'Duración media de las sesiones servidas por bots',
    artificialRate: 'Número de sesiones transferidas al agente/número de sesiones',
    robotEndNum: 'Sesiones finalizadas por bot',
    userEndNum: 'Sesiones finalizadas por el usuario (Botón/Estrategia)',
    artificialEndNum: 'Sesiones finalizadas por agente',
    roundAvg: 'Promedio de rondas de conversaciones entre bot y usuario por sesión',
    robotLikes: 'Puntuación de satisfacción del bot',
    JSRate: 'Tasa de mensajes de usuario no reconocidos por el bot',
    knowledgeNum: 'Número de respuestas de bots que llegan a la base de conocimientos',
    intentionNum: 'Número de respuestas de bots que aciertan en el reconocimiento de intenciones',
    chatNum: 'Número de respuestas de bots que llegan a chitchat',
    unrecognizedNum: 'Número de mensajes enviados por usuarios no reconocidos por el robot',
    recognizedNum: 'Número de mensajes en los que el bot reconoció la intención del usuario',
    recommendRate: 'Número de mensajes que desencadenan preguntas recomendadas para aclarar las intenciones de los usuarios',
    vsday: 'Anterior 1 día',
    vsday7: 'Anterior 2 dias',
    detailExport: 'Detalles de la exportación',
    total: 'Total',
    date: 'Fecha',
    country: 'País',
    channel: 'Canales',
    download: 'Descargar',
    userLikes: 'CSAT',
    coreData: 'Datos básicos de la empresa',
    likeRate: 'Tasa de satisfacción',
    evaluateRate: 'Tasa de evaluación',
    serverLikeRate: 'Sesiones satisfechas / Sesiones evaluadas de todas las sesiones',
    robotLikeRate: 'Sesiones satisfechas / Sesiones evaluadas entre las sesiones atendidas por bots',
    robotEvaluateRate: 'Tasa de evaluación de bots',
    artificialSuccessRate: 'Número de sesiones transferidas con éxito a seres humanos/número de sesiones transferidas a seres humanos',
    serverEvaluateRate: 'Sesiones evaluadas / Todas las sesiones',
    todayMaxBFNum: 'Concurrencia máxima de robots en la fecha consultada',
    likeNum: 'Satisfecho',
    firstSolutionRate: 'Porcentaje de pedidos consultados sin sesiones duplicadas en 24 horas',
    artificialOkSessions: 'Chats transferidos con éxito',
    todayZXYDNum: 'Pedidos del día',
    ZXYDNum24: 'Pedidos Consultas sin Segundas Consultas en 24h',
    userLikeNum: 'Usuarios satisfechos',
    evalUsers: 'Usuarios evaluados',
    robotEvaluates: 'Número de evaluaciones de bots',
    robotLikeNum: 'Número de Bot Satisfechos',
    userServerEvaluates: 'Evaluaciones sobre el servicio de agentes',
    userServerEvaluateRate: 'Tasa de evaluación del servicio de agentes',
    userServerLikeRate: 'Sesiones satisfechas / Sesiones evaluadas entre las sesiones atendidas por los agentes',
    userServerLikes: 'Evaluaciones satisfactorias sobre el servicio de agentes',
    artificialFailNum: 'Sesiones no transferidas al agente',
    artificialFailEvaluates: 'Evaluaciones sobre transferencias fallidas',
    artificialFailLikes: 'Evaluaciones satisfactorias de transferencias fallidas',
    artificialFailEvaluateRate: 'Tasa de evaluación de las transferencias fallidas',
    artificialLikeRate: 'Sesiones Satisfechas / Sesiones Evaluadas entre Sesiones Bot-to-Agent',
    artificialFailLikeRate: 'Sesiones satisfechas/evaluadas entre las no transferidas al Agente',
    all: 'Todos',
    likeRateAnalysis: 'Análisis CSAT',
    serverEffect: 'Efecto servicio',
    dislikeDistribution: 'Distribución de los motivos de insatisfacción',
    sessionType: 'Tipo de chat',
    robotSession: 'Chat del bot',
    artificialSuccess: 'Transferido con éxito ',
    artificialFail: 'Transferencia fallida',
    artificialSession: 'Chats transferidos al agente',
    botServerSession: 'Sesiones atendidas por Bot',
    artificialOkSession: 'Sesiones transferidas con éxito',
    artificialFailSession: 'Sesiones no transferidas',
    evaluates: 'Evaluacion ',
    channelMerge: 'Una vez activado, se mostrarán los datos agregados de todos los canales; de lo contrario, se mostrarán los datos detallados de cada canal.',
    current_users_total: 'Número de sesiones que se están procesando actualmente o en espera de ser procesadas, no cerradas',
    current_robot_wait: 'Número de sesiones actualmente en espera de ser procesadas por el robot',
    current_agent_sessions: 'Número de sesiones actualmente procesadas por un agente que no se han cerrado',
    current_robot_sessions: 'Número de sesiones actualmente procesadas por robots que no se han cerrado',
    current_agent_wait_sessions: 'Número de sesiones en cola iniciadas a transferencia manual sin éxito',
    users: 'Contactos',
    sessions: 'Sesiones',
    rr_income: 'Tarifa multisesión de hoy',
    user_messages: 'Mensajes de los usuarios',
    robot_res_time: 'Tiempo de respuesta del bot',
    transfers: 'Chats transferidos al agente',
    transfer_rate: 'Tasa de bots por agente',
    transfers_succeed_rate: 'Tasa de transferencias correctas',
    avg_sessions_time: 'Hora de entrada del usuario a la hora de finalización de la sesión',
    avg_robot_time: 'Hora de inicio del bot para iniciar la transferencia',
    avg_agent_time: 'Hora de finalización de la conversación con el humano',
    max_qps: 'Concurrencia máxima diaria ',
    Knowledge: 'Base de conocimientos',
    All: 'Etiqueta de intención',
    NoRecognize: 'No reconocido',
    user_close: 'Finalizado por usuario',
    robot_close: 'Finalizado por Bot',
    agent_close: 'Finalizado por agentes',
    ascending: 'Ordenar de menor a mayor',
    descending: 'Ordenar de mayor a menor',
    etip1: 'Arrastre las métricas que le interesen al cuadro de vista previa correspondiente.',
    etip2: 'Motivos del final',
    etip3: 'Se han añadido indicadores de datos',
    etip4: 'No hay más indicadores',
    etip5: 'Se han añadido gráficos',
    etip6: 'No hay más gráficos',
    etip7: 'No se ha guardado la información de edición de la página actual, ¿se ha guardado?',
    title1: 'Indicadores en tiempo real',
    title2: 'Indicadores acumulados del día',
    title3: 'Gráficos de datos',
    title4: 'Distribución del reconocimiento de robots',
    title5: 'Motivos del final',
    title6: 'Gráfico de tendencias',
    title7: 'Distribución de procesos robóticos',
    avg_trans_time: 'Tiempo transcurrido desde el inicio de la transferencia a manual hasta el éxito de la transferencia a manual',
    botSessionNum: 'Sesiones Bot',
    agentSessions: 'Chats transferidos al agente',
    story: {
      story_PlaceOrder: 'Enviar paquetes',
      story_DeliveryAsk: 'Inspección de paquetes',
      story_Package_returned: 'Devolución de paquetes',
      story_Change_Information: 'Modificar información',
      story_AskShippingCost2: 'Comprobar gastos de envío',
      sotry_AskEstimatedTimeBeforeDelivery: 'Comprobar el tiempo estimado',
      story_AskBranch: 'Comprobar sucursales',
      story_AskDelivery_Range: 'Compruebe la zona de entrega',
      story_PackageIssues: 'Consultas sobre parcelas',
      story_AskFranchise: 'Consultas sobre franquicias',
      story_TransferArtificial: 'Atención al cliente',
      story_Complaint: 'Complaints'
    },
    userID: 'ID de usuario',
    userName: 'Apodo de usuario',
    localTime: 'Hora local',
    sessionStartTime: 'Hora de inicio de la sesión',
    robotServiceTime: 'Horas de servicio',
    agentServiceTime: 'Horas de servicio humano',
    botServiceTime: 'Horas de servicio para robots',
    agentSessionDuration: 'Horas de servicio humano',
    botService: 'Servicio de robots',
    agentSession: 'Atención al cliente',
    waybill: 'Número de albarán legal',
    sessionEndTime: 'Hora de finalización de la sesión',
    sessionDur: 'Duración de la sesión',
    serverStatus: 'Estado del servicio',
    robotServer: 'Servicio de robots',
    userServer: 'Atención al cliente',
    noLikeReason: 'Motivos de insatisfacción',
    sessionDetail: 'Detalles de la conversación',
    prevOne: 'Anterior',
    nextOne: 'Siguiente',
    cannelTitle: 'Añada canales de mensajería para comunicarse eficazmente con sus usuarios.',
    noChannel: 'Puedes conectar todas tus cuentas de mensajería empresarial, que llamamos canales, en nuestra plataforma. Vamos a añadir un canal juntos.',
    addCannnel: 'Nuevo canal',
    delete: 'Eliminar',
    edit: 'Editar',
    detail: 'Detalles',
    duplicate: 'Duplicado',
    action: 'Operaciones',
    addTime: 'Crear tiempo',
    updateTime: 'Hora de actualización',
    updater: 'Operacion',
    accountName: 'Nombre de la cuenta',
    dialogueLink: 'Enlace de diálogo',
    last: 'Anterior',
    next: 'Siguiente paso',
    next2: 'Ya tenía, Siguiente',
    authorize: 'Autorizar cuenta',
    stepVal: 'Paso {num}',
    viberPanel: 'Panel de bots de Viber',
    almost: 'Ya casi está',
    addBind: 'Nueva encuadernación',
    editBind: 'Editar encuadernación',
    effectChannel: 'Canal eficaz',
    robotId: 'ID del robot',
    versionId: 'Versión ID',
    channelName: 'Nombre del canal',
    channelId: 'Canal ID',
    updateAccount: 'Actualizar cuenta',
    seeRecord: 'Comprobar registros',
    save: 'Guardar',
    cancel: 'Cancelar',
    submit: 'Enviar',
    remark: 'Observaciones',
    facebookBtn: 'Enlace Facebook',
    connectChannel: 'Canales de autorización',
    newInf: 'Añadir mensaje',
    editInf: 'Editar mensaje',
    name: 'Nombre',
    company: 'Empresa',
    proxy: 'Proxy',
    reqName: 'Nombre de la solicitud',
    tmplName: 'Nombre de la plantilla',
    saveDraft: 'Guardar como borrador',
    saveSubmit: 'Guardar y enviar',
    wbTmplStatus: {
      draft: 'Borradores',
      rejected: 'Fallido',
      submitted: 'Revisión en curso',
      approved: 'Aprobado'
    },
    unknown: 'Desconocido',
    broadcastList: 'Lista de difusión',
    broadcastName: 'Nombre de emisión',
    sendAccount: 'Enviar por',
    broadcastTmpl: 'Broadcast Template',
    newBroadcast: 'Nueva emisión',
    broadcastDetail: 'Detalles de la emisión',
    broadcastData: 'Datos de difusión',
    taskList: 'Lista de tareas',
    tmplInf: 'Información sobre plantillas',
    copyTask: 'Copiar tarea',
    broadcastTime: 'Hora de emisión',
    selectTmpl: 'Seleccionar plantilla',
    upContacts: 'Cargar lista',
    setTime: 'Hora fijada',
    taskStatus: {
      failed: 'Fallido',
      wait: 'No enviado',
      sending: 'Enviando',
      sent: 'Enviado ',
      delivery: 'Entregado',
      read: 'Leer',
      replied: 'Respondió'
    },
    taskNum: 'Número de listas',
    sentNum: 'Mensajes enviados ',
    deliveredNum: 'Mensajes entregados ',
    readNum: 'Mensajes leídos ',
    replies: 'Respuestas',
    failNum: 'Fallo',
    deliveredRate: 'Tasa de entrega',
    readRate: 'Leer tarifa',
    replyRate: 'Tasa de respuesta',
    sendNow: 'Enviar ahora',
    sendSchedule: 'Enviar con cita previa',
    sendTime: 'Tiempo de envio',
    account: 'Número de cuenta',
    downloadTmpl: 'Descargar la plantilla',
    reupload: 'Volver a cargar',
    sendResults: 'Resultado del envío',
    broadcastStatus: 'Estado de la emisión',
    userAccount: 'Cuenta de usuario',
    userOptOut: 'Exclusión voluntaria del usuario',
    batchAdd: 'Añadir lote',
    seatMark: 'Observación del agente',
    addNameLs: 'Añadir lista',
    moreDetails: 'Ver más',
    optOutStartTime: 'Fecha de inicio de la exclusión voluntaria',
    optOutEndTime: 'Fecha de finalización de la exclusión',
    remove: 'Eliminar',
    tip: {
      userNum: 'Número de usuarios entrantes distintos',
      sessionNum: 'Sesiones',
      repeatRate: 'Número de sesiones iniciadas por un usuario que inició varias durante el día/ Número total de todas las sesiones',
      userNews: 'Número de mensajes enviados por los usuarios',
      robotTimes: 'Sesiones atendidas por el bot, tiempo medio de ejecución de una sola respuesta',
      robotBFNum: 'Número de clientes actualmente en sesión con el bot',
      artificialNum: 'Número de sesiones transferidas de bot a humano',
      artificialRate: 'Número de sesiones transferidas al agente/número de sesiones',
      robotWaitNum: 'Número de sesiones en espera de bot',
      artificialWaitNum: 'Número de sesiones en espera de agente',
      artificialCalls: 'Tiempo medio de ejecución de una sola respuesta para las sesiones atendidas por el agente',
      callsAvg: 'Tiempo medio de respuesta única',
      sessionAvg: 'Número medio de minutos para todas las sesiones',
      robotEndNum: 'Sesiones finalizadas por bot',
      userEndNum: 'Sesiones finalizadas por el usuario (Botón/Estrategia)',
      artificialEndNum: 'Sesiones finalizadas por agente',
      roundAvg: 'Promedio de rondas de conversaciones entre bot y usuario por sesión',
      JSRate: 'Tasa de mensajes de usuario no reconocidos por el bot',
      recognizedNum: 'Número de mensajes en los que el bot reconoció la intención del usuario',
      recommendRate: 'Número de mensajes que desencadenan preguntas recomendadas para aclarar las intenciones de los usuarios',
      knowledgeNum: 'Número de respuestas de bots que llegan a la base de conocimientos',
      intentionNum: 'Número de respuestas de bots que aciertan en el reconocimiento de intenciones',
      chatNum: 'Número de respuestas de bots que llegan a chitchat',
      unrecognizedNum: 'Número de mensajes enviados por usuarios no reconocidos por el robot',
      robotSessionAvg: 'Duración media de las sesiones servidas por bots',
      firstSolutionRate: 'Porcentaje de pedidos consultados sin sesiones duplicadas en 24 horas',
      todayMaxBFNum: 'Concurrencia máxima de robots en la fecha consultada',
      serverLikeRate: 'Sesiones satisfechas / Sesiones evaluadas de todas las sesiones',
      serverEvaluateRate: 'Sesiones evaluadas / Todas las sesiones',
      artificialSuccessRate: 'Número de sesiones transferidas con éxito a seres humanos/número de sesiones transferidas a seres humanos',
      robotLikeRate: 'Sesiones satisfechas / Sesiones evaluadas entre las sesiones atendidas por bots',
      artificialLikeRate: 'Sesiones Satisfechas / Sesiones Evaluadas entre Sesiones Bot-to-Agent',
      userServerLikeRate: 'Sesiones satisfechas / Sesiones evaluadas entre las sesiones atendidas por los agentes',
      artificialFailLikeRate: 'Sesiones satisfechas/evaluadas entre las no transferidas al Agente',
      channelMerge: 'Una vez activado, se mostrarán los datos agregados de todos los canales; de lo contrario, se mostrarán los datos detallados de cada canal.',
      plsDayVal: 'Hasta {num} días',
      plsFutureDayVal: 'Seleccione un plazo dentro de los próximos {num} días',
      noChannel: 'Puedes conectar todas tus cuentas de mensajería empresarial, que llamamos canales, en nuestra plataforma. Vamos a añadir un canal juntos.',
      facebookTitle: 'Necesitamos algunos permisos para gestionar los mensajes de tu página de inicio para recibir y responder a los mensajes y comentarios en Messenger.',
      facebookStep1: 'Debido a las normas de bloqueo de Facebook, autoriza y vincula el ordenador que utilizas habitualmente para acceder a tu cuenta de Facebook.',
      facebookStep1_des: 'Antes de la autorización, asegúrate de que eres el administrador de tu página de fans de Facebook.',
      facebookStep2: 'Si recibe un mensaje de error, compruebe si su red funciona correctamente, actualice la página e inténtelo de nuevo.',
      facebookStep3: 'Accede a tu cuenta de Facebook y marca las casillas de las páginas de fans que quieras autorizar.',
      insTitle: 'Asegúrate de que tienes la cuenta profesional de Instagram.',
      insStep1_1: 'Por favor, cambia tu cuenta de Instagram a cuenta Profesional antes de autorizar AI Rudder.',
      insStep1_2: 'Si necesita ayuda, consulte:',
      insStep1_3: 'Cambiar a cuenta profesional en Instagram',
      whatsappStep1: 'Número de teléfono nunca registrado en WhatsApp que puede recibir SMS o llamadas',
      whatsappStep2: 'Administrador de negocios de Facebook verificado',
      lineTitle: 'Por favor, crea el canal API de mensajería de Line bajo el mismo Provides, y luego proporciona la siguiente información para añadir una cuenta de Line.',
      botTokenProvide: 'Por favor, proporcione el Bot Token obtenido en {name} para completar la autorización.',
      authorizeSuccess: 'Autorización aceptada',
      authorizeFail: 'Autorización fallida',
      delChannel: 'Si revocas la autorización de este canal, ya no podrás interactuar con tus contactos a través de este canal. Estás seguro de que quieres revocar la autorización?',
      repeatChannel: 'La cuenta ya ha sido autorizada, por favor seleccione otra cuenta.',
      plsTelMe: 'Póngase en contacto con nosotros',
      plsScopeFacebook: 'Autoriza la cuenta de Facebook',
      upload: 'Permitir {types} de archivos, el tamaño del archivo no es superior a {size}.',
      uploadSize: 'El tamaño del archivo no debe superar {size}.',
      tmplNameReg: 'Por favor, introduzca minúsculas alfanuméricas o guiones bajos',
      noLikePlsClick: '¿No cabe nada? Haga clic en {name}.',
      broadcastSaveErr: 'Hay un error en la información del usuario en la fila {n} del formulario, por favor, vuelva a cargarla.',
      broadcastSaveRepeat: 'La información del usuario en la fila {n} está duplicada, compruébelo y vuelva a cargarla.',
      broadcastSaveOverload: 'El número de usuarios cargados supera el límite máximo de una sola emisión, por favor, vuelva a cargar.',
      broadcastDelTask: 'Las tareas no se pueden restaurar después de borrarlas. ¿Está seguro de que desea continuar?',
      broadcastLimtNum: 'Cuenta corriente {name}, el límite de envío es: {n}/24 horas, más allá del límite se enviará fallo.',
      broadcastDLTitle: 'Descargar esta plantilla de emisión',
      broadcastDLTip1: 'Por favor, rellene la información variable para cada usuario, y la parte sin rellenar se rellenará con valores por defecto.',
      broadcastDLTip2: 'Sólo se permite cargar archivos de tipo xlsx/csv y que no superen 1 MB. Hasta 3.000 cargas en una sola tarea.',
      broadcastReplies: 'Tras un envío correcto, número de contactos que respondieron en 24 horas.',
      removeOptOut: 'Una vez que se elimine a este usuario de la lista de exclusión, el usuario recibirá futuros mensajes de difusión enviados por esta WABA. ¿Desea continuar?',
      optOutTerm: 'Nota: Cualquier usuario añadido no recibirá mensajes de difusión de la WABA durante 90 días.',
      batchTelUp: 'Admite la carga por lotes, se requieren saltos de línea entre los números<br>Ejemplo:<br>+628122218888888<br>+628122217777777',
      avg_sessions_time: 'Hora de entrada del usuario a la hora de finalización de la sesión',
      avg_robot_time: 'Hora de inicio del bot para iniciar la transferencia',
      avg_agent_time: 'Hora de finalización de la conversación con el humano',
      avg_trans_time: 'Tiempo transcurrido desde el inicio de la transferencia a manual hasta el éxito de la transferencia a manual',
      current_users_total: 'Número de sesiones que se están procesando actualmente o en espera de ser procesadas, no cerradas',
      current_robot_wait: 'Número de sesiones actualmente en espera de ser procesadas por el robot',
      current_agent_sessions: 'Número de sesiones actualmente procesadas por un agente que no se han cerrado',
      current_robot_sessions: 'Número de sesiones actualmente procesadas por robots que no se han cerrado',
      current_agent_wait_sessions: 'Número de sesiones en cola iniciadas a transferencia manual sin éxito',
      downloadTip: 'La descarga de registros de llamadas con más de 5000 entradas se dividirá en varios archivos, ¿desea continuar?'
    },
    wbTmplTip: {
      header: 'Añada un título o seleccione el tipo de medio utilizado por esta Cabecera',
      body: 'Para añadir una variable personalizada, añada una variable en {{}} sin espacios.',
      body2: 'Por ejemplo: {{name}}',
      footer: 'Añade una breve línea de texto al final del mensaje de tu plantilla.',
      buttons: 'Añadir una respuesta rápida o un botón CTA',
      buttonLimit: 'Los botones no deben tener variables, saltos de línea ni emoticonos.',
      variables: 'Por favor, asegúrese de no incluir ninguna información real del usuario o cliente y proporcione sólo contenido de muestra en los ejemplos.',
      sample: 'Sample content for {name}',
      del: 'Después de borrar la plantilla, la plantilla con el mismo nombre no se puede aplicar durante 30 días, por favor confirme si debe borrarla o no.',
      variableRepeat: 'Los nombres de las variables no pueden duplicarse.',
      optOutBtn: 'Opción de darse de baja: Si el usuario hace clic en el botón Darse de baja, dejará de recibir mensajes de difusión de la WABA durante 90 días. '
    }
  },
  teamInbox: {
    all_chat: 'Todos',
    my_chat: 'Mio',
    manuanling: 'sin asignar',
    broadcast: 'difusión',
    bot: 'Robot',
    closed: 'Cerrado',
    broadcastinfo: 'Sesión de radiodifusión',
    botinfo: 'Chat del bot',
    broadcastType: 'No iniciado',
    botType: 'Bot',
    manuanlingType: 'Sin asignar',
    manualedType: 'En conversación con {user}',
    closedType: 'Cerrado',
    jiesu: 'Fin de la sesión',
    jieg: 'Sesión de control',
    userInfo: 'Información al cliente',
    chatTitle: 'Sesiones de agentes',
    manualedAMType: 'Adelante a',
    duihua: 'En conversación',
    changeUser: 'Acuse de recibo de la transferencia del diálogo a.',
    tips: 'Llamar la atención sobre algo',
    yes: 'Si',
    no: 'No',
    noType: 'Este tipo de mensaje no se admite actualmente.',
    start: '{name} inició una nueva sesión.',
    close: '{name} ha cerrado la sesión.',
    take_over: '{name} asume la sesión',
    hand_over: '{name} transfiere la sesión a {toName}.',
    msgSet: 'Configuración de mensajes'
  },
  security: {
    session: 'Gestión de Tiempo de Expiración de Sesión',
    defaultSession: 'Tiempo de Expiración de Sesión Predeterminado',
    userInLogin: 'Después de iniciar sesión durante',
    autoLogout: 'el usuario cerrará sesión automáticamente. (Rango válido: 1-24 horas)',
    idleSessionTimeout: 'Tiempo de Expiración de Sesión Inactiva',
    userIn: 'Sin actividad durante',
    noRun: 'entonces, la cuenta cerrará sesión automáticamente. (Rango válido: 5 minutos a 24 horas)',
    pl1: 'Por favor, ingrese un número entero entre {num1} y {num2}.',
    accountLock: 'Gestión de Bloqueo de Cuenta',
    maxError: 'Máximo de Intentos de Inicio de Sesión Fallidos antes de Bloquear la Cuenta',
    lockTime: 'Duración del Bloqueo',
    lockTipBase: '(Después de que la cuenta esté bloqueada, se cerrará automáticamente la sesión y los intentos de inicio de sesión estarán desactivados durante el período de bloqueo.)',
    counter: 'Intervalo de Reinicio del Contador',
    counterTip: '(Después de este intervalo de tiempo, se reiniciará el contador de intentos de inicio de sesión fallidos y se reiniciará a 0.)',
    couMag: 'Gestión de Inicio de Sesión Concurrente',
    oneAccount: 'Una cuenta única puede iniciar sesión simultáneamente',
    bro: 'dispositivos/navegadores.',
    forMag: 'Gestión de Desactivación de Cuenta',
    ifMag: 'Si una cuenta no ha iniciado sesión dentro del período de validez, se desactivarán los intentos de inicio de sesión adicionales.',
    nearMag: 'Notificación del último inicio de sesión',
    loginSuccess: 'Al iniciar sesión correctamente, se mostrará la última hora de inicio de sesión.',
    accountTrue: 'Tiempo de espera de caducidad de inicio de sesión',
    saveTip: 'Modificar la configuración de seguridad de la cuenta afectará el comportamiento de la cuenta y todas sus subcuentas. ¿Está seguro de que desea continuar con la modificación?',
    loginLockTip: 'Nombre de usuario o contraseña incorrectos. Si se ingresan incorrectamente {errorNum} veces más, el usuario quedará bloqueado durante {errorMin} minutos.',
    forTip: 'Esta cuenta de usuario ha sido desactivada. Por favor, contacte al administrador o a nuestro equipo de soporte para obtener ayuda.',
    lockTip: 'La cuenta de usuario actual está bloqueada. Por favor, inténtelo de nuevo después de {errorMin} minutos.',
    loginSuccess2: 'Inicio de Sesión Exitoso',
    last: 'Información del Último Inicio de Sesión',
    moreTip: 'Lo sentimos, la frecuencia de acceso ha superado el límite. Por favor, inténtelo de nuevo más tarde.',
    lockTip2: 'Su cuenta ha sido bloqueada. Por favor, inténtelo de nuevo.',
    userStatus: 'Estado de la Cuenta',
    visitStatus: 'Estado de Acceso'
  }
}



// WEBPACK FOOTER //
// ./src/lang/es.js